export const translations = {
    en: {
        language: {
            label: "Language",
            english: "English",
            ukrainian: "Ukrainian",
        },
        common: {
            na: "N/A",
            appName: "Fit-Log",
            back: "Back",
        },
        breadcrumbs: {
            ariaLabel: "Breadcrumb",
            dashboard: "Dashboard",
            selectExercise: "Choose Exercise",
            createExercise: "Create Exercise",
            logExerciseSection: "Log Exercise",
            logExercise: "Log Exercise: {exercise}",
        },
        home: {
            title: "Track Sets, Reps & Weights",
            subtitle: "A simple workout log for daily strength training.",
            loggedToday: "Exercises Logged Today",
            searchExercises: "Search Exercises",
            exercise: "Exercise",
            date: "Date",
            setsCount: "Sets",
            weight: "Weight",
            logExercise: "Log Exercise",
            progressTitle: "My Progress Over Time",
            progressTabsLabel: "Progress view",
            progressByMuscleGroups: "By Muscle Groups",
            progressByDate: "By Date",
            toggleIndirect: "Show Indirectly Impacted Muscles",
            toggleIndirectAria: "Toggle showing exercises with indirect muscle impact",
            noData: "No data available.",
            workoutTracker: "Workout Tracker",
            exerciseHistoryTable: "Exercise history by date",
            muscleGroup: "Muscle Group",
            addExerciseFor: "Add exercise for {group}",
            emptyStateTitle: "You haven't logged any exercises today.",
            jsonLdDescription:
                "Fit-Log is a lightweight tracker for sets, reps, and weights. Log exercises and track workout progress.",
            unknownExercise: "Unknown ({id})",
        },
        legend: {
            direct: "Directly impacts muscle group",
            indirect: "Indirectly impacts muscle group",
        },
        select: {
            title: "Choose an Exercise",
            titleForMuscle: "Choose {muscle} Exercises",
            createExercise: "Create Exercise",
            createNewExercise: "New Exercise",
            modeRecent: "Recent",
            modeSearch: "Search or Create",
            modeWizard: "Wizard",
            modeSwitchAria: "Exercise selection mode",
            stepsTitle: "Workout logging steps",
            stepOneNumber: "1",
            stepOneText: "Choose or create a new exercise",
            stepTwoNumber: "2",
            stepTwoText: "Log weights and reps",
            searchPlaceholder: "Search exercises or enter a new name",
            searchStartPrompt: "Enter at least one letter to start searching.",
            searchTooManyResults: "Refine the search, there are too many exercises.",
            searchCount: "Exercises ({count})",
            existingExercises: "Exercises",
            filters: "Filters",
            filtersCount: "Filters ({count})",
            equipment: "Equipment",
            equipmentFilterAria: "Equipment filter",
            muscleGroup: "Muscle Group",
            muscleFilterAria: "Muscle filter",
            recentExercises: "Recent Exercises",
            otherExercises: "Other Exercises",
            directExercises: "Direct Exercises",
            indirectExercises: "Indirect Exercises",
            noExercisesFound: "No exercises found.",
            noRecentExercises: "No recent exercises. They will appear here after logging.",
            allExercises: "All Exercises",
            equipmentExercises: "Exercises: {equipment}",
            all: "All",
            seoTitle: "{muscle} Exercises - Lightweight Tracker for Sets, Reps & Weights",
            seoTitleAll: "Exercises - Lightweight Tracker for Sets, Reps & Weights",
            seoDescription:
                "Browse and filter exercises by equipment and muscle group, then log sets, reps, and weights with Fit-Log.",
            seoDescriptionMuscle: "Browse {muscle} exercises and log sets, reps, and weights with Fit-Log.",
            wizard: {
                title: "Find an exercise step by step",
                subtitle: "Answer a few short questions and narrow the list down fast.",
                remaining: "{count} exercises left",
                answersLabel: "Selected",
                results: "Matching Exercises",
                back: "Back",
                skip: "Skip",
                reset: "Reset",
                noResults: "No exercises match these answers.",
                questions: {
                    equipmentFamily: "What do you use for this exercise?",
                    implement: "Which free weight do you use?",
                    support: "What kind of support or position is involved?",
                    movement: "What kind of movement is it?",
                    mainArea: "What area is the main focus?",
                },
                options: {
                    equipmentFamily: {
                        machine: "Machine",
                        cable: "Cable",
                        free_weight: "Free Weight",
                        bodyweight: "Bodyweight",
                        cardio: "Cardio",
                        other: "Other",
                    },
                    implement: {
                        barbell: "Barbell",
                        dumbbell: "Dumbbell",
                        kettlebell: "Kettlebell",
                        specialty_bar: "Specialty Bar",
                        medicine_ball: "Medicine Ball",
                        other: "Other",
                    },
                    support: {
                        bench: "Bench",
                        seat: "Seated",
                        standing: "Standing",
                        floor: "Floor",
                        hanging: "Hanging",
                        other: "Other",
                    },
                    movement: {
                        press: "Press",
                        pull: "Pull",
                        squat_or_lunge: "Squat or Lunge",
                        hinge: "Hinge",
                        raise_or_curl: "Isolation",
                        core_or_carry: "Core or Carry",
                    },
                    mainArea: {
                        chest: "Chest",
                        back: "Back",
                        shoulders: "Shoulders",
                        legs: "Legs",
                        arms: "Arms",
                        core: "Core",
                    },
                },
            },
        },
        createExercise: {
            title: "Create Exercise",
            backToExercises: "Back to Exercises",
            nameLabel: "Exercise Name",
            namePlaceholder: "Enter exercise name",
            primaryMuscleGroup: "Primary Muscle Group",
            save: "Save Exercise",
            saving: "Saving...",
            seoTitle: "Create Exercise - Lightweight Tracker for Sets, Reps & Weights",
            seoDescription: "Create a custom exercise, assign its primary muscle group, and start logging it in Fit-Log.",
            errorPrefix: "Error:",
            nameRequired: "Please enter an exercise name.",
            muscleGroupRequired: "Please select a primary muscle group.",
            duplicateName: "An exercise with this name already exists.",
            saveFailed: "Failed to save the exercise.",
        },
        equipment: {
            All: "All",
            Barbell: "Barbell",
            Dumbbell: "Dumbbell",
            Cable: "Cable",
            Machine: "Machine",
            "Smith Machine": "Smith Machine",
            "Specialty Bar": "Specialty Bar",
            Functional: "Functional",
            Kettlebell: "Kettlebell",
            "Medicine Ball": "Medicine Ball",
            Bodyweight: "Bodyweight",
            "Cardio Machine": "Cardio Machine",
            Other: "Other",
        },
        exercises: {
        bench_press: "Bench Press",
        incline_bench_press: "Incline Bench Press",
        decline_bench_press: "Decline Bench Press",
        squat: "Squat",
        front_squat: "Front Squat",
        deadlift: "Deadlift",
        romanian_deadlift: "Romanian Deadlift",
        overhead_press: "Overhead Press",
        barbell_curl: "Barbell Curl",
        close_grip_bench_press: "Close Grip Bench Press",
        barbell_shrug: "Barbell Shrug",
        barbell_hip_thrust: "Barbell Hip Thrust",
        barbell_hack_squat: "Barbell Hack Squat",
        zercher_squat: "Zercher Squat",
        barbell_upright_row: "Barbell Upright Row",
        barbell_drag_curl: "Barbell Drag Curl",
        barbell_floor_press: "Barbell Floor Press",
        barbell_landmine_press: "Barbell Landmine Press",
        sumo_squat: "Sumo Squat",
        good_morning: "Good Morning",
        push_press: "Push Press",
        barbell_front_raise: "Barbell Front Raise",
        barbell_behind_the_neck_press: "Barbell Behind-the-Neck Press",
        wide_grip_barbell_row: "Wide-Grip Barbell Row (elbows flared)",
        reverse_shrug: "Reverse Shrug (targets traps and posterior delts)",
        plate_around_the_world: "Plate Around the World (shoulders, including rear delts)",
        barbell_side_bend: "Barbell Side Bend",
        barbell_back_squat: "Barbell Back Squat",
        barbell_front_squat: "Barbell Front Squat",
        barbell_box_squat: "Barbell Box Squat",
        barbell_overhead_squat: "Barbell Overhead Squat",
        barbell_romanian_deadlift: "Barbell Romanian Deadlift",
        barbell_conventional_deadlift: "Barbell Conventional Deadlift",
        barbell_sumo_deadlift: "Barbell Sumo Deadlift",
        barbell_good_morning: "Barbell Good Morning",
        barbell_lunge: "Barbell Lunge",
        barbell_reverse_lunge: "Barbell Reverse Lunge",
        barbell_bulgarian_split_squat: "Barbell Bulgarian Split Squat",
        barbell_step_up: "Barbell Step-Up",
        barbell_bench_press: "Barbell Bench Press",
        barbell_incline_bench_press: "Barbell Incline Bench Press",
        barbell_decline_bench_press: "Barbell Decline Bench Press",
        barbell_close_grip_bench_press: "Barbell Close-Grip Bench Press",
        barbell_overhead_press: "Barbell Overhead Press",
        barbell_push_press: "Barbell Push Press",
        barbell_bent_over_row: "Barbell Bent-Over Row",
        barbell_pendlay_row: "Barbell Pendlay Row",
        barbell_chest_supported_row: "Barbell Chest-Supported Row",
        barbell_biceps_curl: "Barbell Biceps Curl",
        barbell_preacher_curl: "Barbell Preacher Curl",
        barbell_skull_crusher: "Barbell Skull Crusher",
        barbell_glute_bridge: "Barbell Glute Bridge",
        barbell_front_rack_lunge: "Barbell Front Rack Lunge",
        barbell_zercher_squat: "Barbell Zercher Squat",
        barbell_power_clean: "Barbell Power Clean",
        barbell_clean_and_press: "Barbell Clean and Press",
        barbell_high_pull: "Barbell High Pull",
        barbell_thruster: "Barbell Thruster",
        barbell_rollout: "Barbell Rollout",
        bodyweight_squat: "Bodyweight Squat",
        sumo_squat_bodyweight: "Sumo Squat",
        jump_squat: "Jump Squat",
        split_squat_bodyweight: "Split Squat",
        bulgarian_split_squat_bodyweight: "Bulgarian Split Squat",
        walking_lunge: "Walking Lunge",
        reverse_lunge_bodyweight: "Reverse Lunge",
        lateral_lunge_bodyweight: "Lateral Lunge",
        curtsy_lunge_bodyweight: "Curtsy Lunge",
        step_up_bodyweight: "Step-Up",
        shrimp_squat: "Shrimp Squat",
        pistol_squat: "Pistol Squat",
        wall_sit: "Wall Sit",
        glute_bridge: "Glute Bridge",
        single_leg_glute_bridge: "Single-Leg Glute Bridge",
        hip_thrust_bodyweight: "Bodyweight Hip Thrust",
        glute_bridge_march: "Glute Bridge March",
        hamstring_walkout: "Hamstring Walkout",
        nordic_curl_assisted: "Assisted Nordic Curl",
        sliding_leg_curl: "Sliding Leg Curl",
        single_leg_deadlift_balance: "Single-Leg Deadlift Balance",
        glute_ham_raise_bodyweight: "Bodyweight Glute-Ham Raise",
        calf_raise_standing: "Standing Calf Raise",
        single_leg_calf_raise: "Single-Leg Calf Raise",
        deep_squat_hold: "Deep Squat Hold",
        plank: "Plank",
        side_plank: "Side Plank",
        copenhagen_plank: "Copenhagen Plank",
        side_bridge: "Side Bridge",
        side_bend: "Side Bend",
        reverse_plank: "Reverse Plank",
        hollow_body_hold: "Hollow Body Hold (Hollow Hold)",
        dead_bug: "Dead Bug",
        bird_dog: "Bird Dog",
        superman_hold: "Superman Hold",
        lying_leg_raise: "Lying Leg Raise",
        hanging_knee_raise: "Hanging Knee Raise",
        seated_knee_tuck: "Seated Knee Tuck",
        bicycle_crunch: "Bicycle Crunch",
        russian_twist: "Russian Twist",
        lying_windshield_wiper: "Lying Windshield Wiper",
        mountain_climber: "Mountain Climber",
        push_up: "Push-Up",
        pull_up: "Pull-Up",
        chin_up: "Chin-Up",
        bodyweight_dips: "Dips",
        burpee: "Burpee",
        hanging_leg_raise: "Hanging Leg Raise",
        sit_up: "Sit-Up",
        v_up: "V-Up",
        back_extension: "Back Extension",
        inverted_row: "Inverted Row",
        pike_push_up: "Pike Push-Up",
        handstand_push_up: "Handstand Push-Up",
        bench_triceps_dip: "Triceps Dip on Bench",
        bear_crawl: "Bear Crawl",
        cable_front_squat: "Cable Front Squat",
        cable_goblet_squat: "Cable Goblet Squat",
        cable_sumosquat: "Cable Sumo Squat",
        cable_split_squat: "Cable Split Squat",
        cable_bulgarian_split_squat: "Cable Bulgarian Split Squat",
        cable_reverse_lunge: "Cable Reverse Lunge",
        cable_curtsy_lunge: "Cable Curtsy Lunge",
        cable_lateral_lunge: "Cable Lateral Lunge",
        cable_walking_lunge: "Cable Walking Lunge",
        cable_step_up: "Cable Step-Up",
        cable_pistol_squat_assist: "Cable Pistol Squat Assist",
        cable_single_leg_deadlift: "Cable Single-Leg Deadlift",
        cable_romanian_deadlift: "Cable Romanian Deadlift",
        cable_good_morning: "Cable Good Morning",
        cable_pull_through: "Cable Pull-Through",
        cable_glute_bridge: "Cable Glute Bridge",
        cable_hip_thrust: "Cable Hip Thrust",
        cable_glute_kickback: "Cable Glute Kickback",
        cable_donkey_kick: "Cable Donkey Kick",
        cable_fire_hydrant: "Cable Fire Hydrant",
        cable_standing_hip_abduction: "Cable Standing Hip Abduction",
        cable_standing_hip_adduction: "Cable Standing Hip Adduction",
        cable_leg_curl_standing: "Cable Standing Leg Curl",
        cable_leg_curl_kneeling: "Cable Kneeling Leg Curl",
        cable_prone_leg_curl: "Cable Prone Leg Curl",
        cable_standing_calf_raise: "Cable Standing Calf Raise",
        cable_single_leg_calf_raise: "Cable Single-Leg Calf Raise",
        cable_seated_calf_raise: "Cable Seated Calf Raise",
        dual_cable_crunch: "Dual Cable Crunch",
        cable_kneeling_crunch: "Cable Kneeling Crunch",
        cable_reverse_crunch: "Cable Reverse Crunch",
        cable_v_sit_pull: "Cable V-Sit Pull",
        cable_jackknife: "Cable Jackknife",
        cable_pallof_press: "Cable Pallof Press",
        high_pulley_woodchop: "High Pulley Woodchop",
        low_to_high_cable_woodchop: "Low-to-High Cable Woodchop",
        cable_oblique_crunch: "Cable Oblique Crunch",
        cable_side_bend: "Cable Side Bend",
        cable_anti_rotation_press: "Cable Anti-Rotation Press",
        cable_back_extension: "Cable Back Extension",
        cable_crossover: "Cable Crossover",
        cable_chest_fly: "Cable Chest Fly",
        cable_incline_fly: "Cable Incline Fly",
        cable_low_fly: "Cable Low Fly",
        cable_biceps_curl: "Cable Biceps Curl",
        cable_rope_hammer_curl: "Cable Rope Hammer Curl",
        cable_triceps_pushdown: "Cable Triceps Pushdown",
        cable_overhead_triceps_extension: "Cable Overhead Triceps Extension",
        cable_face_pull: "Cable Face Pull",
        cable_lateral_raise: "Cable Lateral Raise",
        cable_front_raise: "Cable Front Raise",
        cable_upright_row: "Cable Upright Row",
        cable_row: "Cable Row",
        cable_seated_row: "Seated Cable Row",
        cable_lat_pulldown: "Cable Lat Pulldown",
        cable_straight_arm_pulldown: "Cable Straight-Arm Pulldown",
        cable_woodchopper: "Cable Woodchopper",
        cable_reverse_woodchopper: "Cable Reverse Woodchopper",
        cable_crunch: "Cable Crunch",
        cable_kickback_triceps: "Cable Kickback (Triceps)",
        cable_single_arm_row: "Cable Single-Arm Row",
        cable_rear_delt_fly: "Cable Rear Delt Fly",
        treadmill: "Treadmill",
        elliptical_trainer: "Elliptical Trainer (Cross-Trainer)",
        upright_bike: "Upright Stationary Bike",
        recumbent_bike: "Recumbent Bike",
        spin_bike: "Indoor Cycling / Spin Bike",
        rowing_machine: "Rowing Machine",
        stair_climber: "Stair Climber / Stepmill",
        skierg: "SkiErg",
        bikeerg: "BikeErg",
        arc_trainer: "Arc Trainer",
        curved_treadmill: "Manual Curved Treadmill (Air Runner)",
        vertical_climber: "VersaClimber / Vertical Climber",
        adaptive_motion_trainer: "Adaptive Motion Trainer (AMT)",
        recumbent_stepper: "Recumbent Stepper",
        hybrid_row_bike: "Hybrid Row-Bike Machine",
        assault_bike: "AirDyne / Assault Bike",
        battle_ropes_station: "Battle Ropes Station",
        sled_push_track: "Sled Push Track",
        skillmill: "SkillMill / Motorized Non-Electric Runner",
        vibration_plate: "Vibration Plate Trainer",
        climbing_wall_simulator: "Climbing Wall Simulator",
        hydraulic_rower: "Hydraulic Rowers / Resistance Trainers",
        cardio_boxing_machine: "Cardio Boxing Machines",
        digital_interactive_trainer: "Digital Interactive Trainer",
        recovery_boots: "Recovery Boots / Compression Therapy Station",
        swimming: "Swimming (especially freestyle and butterfly)",
        cross_country_skiing: "Cross-Country Skiing",
        boxing_punching: "Boxing/Punching",
        jump_rope: "Jump Rope",
        indoor_track: "Indoor Track",
        dumbbell_front_squat: "Dumbbell Front Squat",
        dumbbell_goblet_squat: "Dumbbell Goblet Squat",
        dumbbell_back_squat: "Dumbbell Back Squat",
        dumbbell_sumosquat: "Dumbbell Sumo Squat",
        dumbbell_split_squat: "Dumbbell Split Squat",
        dumbbell_bulgarian_split_squat: "Dumbbell Bulgarian Split Squat",
        dumbbell_reverse_lunge: "Dumbbell Reverse Lunge",
        dumbbell_forward_lunge: "Dumbbell Forward Lunge",
        dumbbell_lateral_lunge: "Dumbbell Lateral Lunge",
        dumbbell_curtsy_lunge: "Dumbbell Curtsy Lunge",
        dumbbell_step_up: "Dumbbell Step-Up",
        dumbbell_box_step_down: "Dumbbell Box Step-Down",
        dumbbell_cossack_squat: "Dumbbell Cossack Squat",
        dumbbell_suitcase_squat: "Dumbbell Suitcase Squat",
        dumbbell_kneeling_squat: "Dumbbell Kneeling Squat",
        dumbbell_lunge_high_knee: "Dumbbell Lunge to High Knee",
        dumbbell_lunge_to_reverse: "Dumbbell Forward-Backward Lunge",
        dumbbell_single_leg_deadlift: "Dumbbell Single-Leg Deadlift",
        dumbbell_romanian_deadlift: "Dumbbell Romanian Deadlift",
        dumbbell_stiff_leg_deadlift: "Dumbbell Stiff-Leg Deadlift",
        dumbbell_suitcase_deadlift: "Dumbbell Suitcase Deadlift",
        dumbbell_good_morning: "Dumbbell Good Morning",
        dumbbell_swing: "Dumbbell Swing",
        dumbbell_glute_bridge: "Dumbbell Glute Bridge",
        dumbbell_single_leg_glute_bridge: "Dumbbell Single-Leg Glute Bridge",
        dumbbell_hip_thrust: "Dumbbell Hip Thrust",
        dumbbell_hamstring_bridge: "Dumbbell Hamstring Bridge",
        dumbbell_glute_kickback: "Dumbbell Glute Kickback",
        dumbbell_donkey_kick: "Dumbbell Donkey Kick",
        dumbbell_fire_hydrant: "Dumbbell Fire Hydrant",
        dumbbell_lateral_leg_raise: "Dumbbell Lateral Leg Raise",
        dumbbell_standing_calf_raise: "Dumbbell Standing Calf Raise",
        dumbbell_single_leg_calf_raise: "Dumbbell Single-Leg Calf Raise",
        dumbbell_seated_calf_raise: "Dumbbell Seated Calf Raise",
        dumbbell_side_bend: "Dumbbell Side Bend",
        dumbbell_russian_twist: "Dumbbell Russian Twist",
        dumbbell_v_sit_press: "Dumbbell V-Sit Press",
        dumbbell_dead_bug: "Dumbbell Dead Bug",
        dumbbell_reverse_crunch: "Dumbbell Reverse Crunch",
        dumbbell_woodchop: "Dumbbell Woodchop",
        dumbbell_pallof_press: "Dumbbell Pallof Press",
        dumbbell_plank_row: "Dumbbell Plank Row",
        dumbbell_suitcase_carry: "Dumbbell Suitcase Carry",
        dumbbell_farmer_carry: "Dumbbell Farmer Carry",
        dumbbell_bench_press: "Dumbbell Bench Press",
        dumbbell_incline_bench_press: "Dumbbell Incline Bench Press",
        dumbbell_decline_bench_press: "Dumbbell Decline Bench Press",
        dumbbell_shoulder_press: "Dumbbell Shoulder Press",
        dumbbell_arnold_press: "Dumbbell Arnold Press",
        dumbbell_lateral_raise: "Dumbbell Lateral Raise",
        dumbbell_front_raise: "Dumbbell Front Raise",
        dumbbell_y_raise: "Dumbbell Y Raise",
        dumbbell_rear_delt_fly: "Dumbbell Rear Delt Fly",
        dumbbell_bent_over_row: "Dumbbell Bent-Over Row",
        dumbbell_single_arm_bench_row: "Dumbbell Single-Arm Bench Row",
        dumbbell_chest_fly: "Dumbbell Chest Fly",
        dumbbell_incline_chest_fly: "Dumbbell Incline Chest Fly",
        dumbbell_lunge: "Dumbbell Lunge",
        dumbbell_hammer_curl: "Dumbbell Hammer Curl",
        dumbbell_biceps_curl: "Dumbbell Biceps Curl",
        dumbbell_concentration_curl: "Dumbbell Concentration Curl",
        dumbbell_triceps_kickback: "Dumbbell Triceps Kickback",
        dumbbell_overhead_triceps_extension: "Dumbbell Overhead Triceps Extension",
        dumbbell_chest_supported_row: "Dumbbell Chest-Supported Row",
        dumbbell_shrug: "Dumbbell Shrug",
        dumbbell_floor_press: "Dumbbell Floor Press",
        dumbbell_pullover: "Dumbbell Pullover",
        thrusters: "Thrusters",
        push_jerk: "Push Jerk",
        clean_and_press: "Clean and Press",
        sandbag_clean_and_press: "Sandbag Clean and Press",
        landmine_press: "Landmine Press",
        landmine_rotations: "Landmine Rotations",
        sled_push: "Sled Push",
        sled_pull: "Sled Pull",
        prowler_push: "Prowler Push",
        tire_flips: "Tire Flips",
        sandbag_carry: "Sandbag Carry",
        sandbag_clean: "Sandbag Clean",
        sandbag_squat: "Sandbag Squat",
        sandbag_floor_press: "Sandbag Floor Press",
        kettlebell_deadlift: "Kettlebell Deadlift",
        kettlebell_squat: "Kettlebell Squat",
        kettlebell_swing: "Kettlebell Swing",
        kettlebell_overhead_press: "Kettlebell Overhead Press",
        kettlebell_arnold_press: "Kettlebell Arnold Press",
        kettlebell_lateral_raise: "Kettlebell Lateral Raise",
        kettlebell_upright_row: "Kettlebell Upright Row",
        kettlebell_halo: "Kettlebell Halo",
        bottoms_up_kettlebell_press: "Bottoms-Up Kettlebell Press",
        turkish_get_up: "Turkish Get-Up",
        kettlebell_clean: "Kettlebell Clean",
        kettlebell_rear_delt_swing: "Kettlebell Rear Delt Swing",
        bent_over_kettlebell_fly: "Bent-Over Kettlebell Fly",
        kettlebell_high_pull: "Kettlebell High Pull (elbows out)",
        bottoms_up_kettlebell_row: "Bottoms-Up Kettlebell Row",
        kettlebell_floor_press: "Kettlebell Floor Press",
        kettlebell_windmill: "Kettlebell Windmill",
        chest_fly_machine_dual_adjustable: "Chest Fly Machine (Dual Adjustable)",
        converging_chest_press_machine: "Converging Chest Press Machine",
        iso_lateral_chest_press: "Iso-Lateral Chest Press (Hammer Strength Chest Press)",
        vertical_chest_press_machine: "Vertical Chest Press Machine",
        lever_chest_press: "Lever Chest Press",
        plate_loaded_chest_fly: "Plate-Loaded Chest Fly",
        incline_lever_chest_press: "Incline Lever Chest Press (Hammer Strength Incline Press)",
        assisted_chest_dips: "Assisted Chest Dips",
        iso_lateral_shoulder_press: "Iso-Lateral Shoulder Press (Hammer Strength Shoulder Press)",
        lever_shoulder_press: "Lever Shoulder Press",
        machine_front_raise: "Machine Front Raise",
        spider_curl_machine: "Spider Curl Machine",
        triceps_dips_assisted_machine: "Assisted Dip Machine (Triceps Dips)",
        wrist_extension_machine: "Wrist Extension on Cable Machine",
        oblique_twists_machine: "Oblique Twists on Cable Machine",
        reverse_crunch_machine: "Reverse Crunch on Cable Machine",
        machine_good_mornings: "Machine Good Mornings",
        forty_five_degree_back_extension: "45-Degree Back Extension Machine",
        roman_chair_hyperextension: "Roman Chair Hyperextension",
        standing_hip_abduction_machine: "Standing Hip Abduction Machine",
        seated_hip_abduction_machine: "Seated Hip Abduction Machine",
        seated_hip_adduction_machine: "Seated Hip Adduction Machine",
        meadow_row_machine: "Meadow Row Machine",
        dead_row_machine: "Dead Row Machine",
        iso_lateral_high_row: "Iso-Lateral High Row",
        one_arm_high_pulley_row: "One Arm High Pulley Row",
        single_arm_seated_row: "Single Arm Seated Row",
        underhand_lat_pulldown: "Underhand Lat Pulldown",
        behind_the_neck_lat_pulldown: "Behind-the-Neck Lat Pulldown",
        unilateral_lat_pulldown: "Unilateral Lat Pulldown",
        plate_loaded_lat_pulldown: "Plate-Loaded Lat Pulldown (Hammer Strength Pulldown, Plate-Loaded Pulldown, Iso-Lateral Pulldown Machine)",
        reverse_pec_deck: "Reverse Pec Deck (Rear Delt Fly Machine / Pec Deck/Rear Delt Combo Machine)",
        reverse_machine_shoulder_press: "Reverse Machine Shoulder Press (leaning forward)",
        rear_delt_row_seated_machine: "Rear Delt Row on Seated Row Machine",
        wide_grip_assisted_pullup: "Assisted Pull-Up (wide grip, leaning back)",
        high_row_machine: "High Row Machine (elbows flared, Hammer Strength High Row)",
        side_hyperextension: "Side Hyperextension",
        weighted_side_hyperextension: "Weighted Side Hyperextension",
        lateral_flexion_machine: "Lateral Flexion Machine",
        machine_row: "Machine Row",
        shoulder_press_machine: "Shoulder Press Machine",
        cable_crossover_machine: "Cable Crossover Machine",
        functional_trainer: "Functional Trainer / Dual Pulley Station (Dual Adjustable Pulley Machine)",
        ab_crunch_machine: "Ab Crunch Machine",
        glute_bridge_machine: "Glute Bridge / Hip Thrust Machine",
        back_extension_bench: "Back Extension / Hyperextension Bench",
        multi_gym_station: "Multi-gym Selectorized Station",
        face_pull_station: "Face Pull / Rope Crossover Station",
        plate_loaded_shoulder_press: "Plate-loaded Shoulder Press",
        plate_loaded_chest_press: "Plate-loaded Chest Press",
        plate_loaded_row_machine: "Plate-loaded Row Machine",
        machine_press: "Machine Press",
        machine_curl: "Machine Curl",
        machine_tricep_pushdown: "Machine Tricep Pushdown",
        machine_leg_extension: "Machine Leg Extension",
        machine_leg_curl: "Machine Leg Curl (Seated Leg Curl Machine)",
        machine_calf_raise: "Machine Calf Raise",
        hack_squat_machine: "Hack Squat Machine (Linear Hack Squat Machine)",
        pec_deck: "Pec Deck/Butterfly Machine (Pec Deck Machine)",
        seated_row_machine: "Seated Row Machine",
        abductor_machine: "Abductor Machine (Outer Thigh Machine / Hip Abductor Machine)",
        adductor_machine: "Adductor Machine (Inner Thigh Machine / Hip Adductor Machine)",
        reverse_hyperextension_machine: "Reverse Hyperextension Machine",
        assisted_pull_up_machine: "Assisted Pull-up Machine",
        assisted_dip_machine: "Assisted Dip Machine",
        leg_press: "Leg Press",
        lat_pulldown: "Lat Pulldown Machine",
        leg_curl: "Leg Curl",
        leg_extension: "Leg Extension",
        lateral_raise_machine: "Lateral Raise Machine (Selectorized / Lateral Raise Selectorized Machine)",
        reverse_fly_machine: "Reverse Fly Machine / Rear Delt Machine",
        shrug_machine: "Shrug Machine",
        seated_row_elevated_scapula_pull: "Seated Row Machine with Elevated Scapula Pull",
        chest_press_machine: "Chest Press Machine",
        incline_chest_press_machine: "Incline Chest Press Machine",
        decline_chest_press_machine: "Decline Chest Press Machine",
        seated_cable_chest_press: "Seated Cable Chest Press",
        lat_pulldown_wide_grip: "Lat Pulldown (wide grip)",
        seated_row_machine_wide_grip: "Seated Row Machine (wide grip)",
        cable_high_row: "Cable High Row",
        lat_pulldown_neutral_grip: "Lat Pulldown (neutral grip)",
        close_grip_seated_row: "Close-Grip Seated Row",
        hammer_strength_row: "Hammer Strength Row",
        machine_pullover: "Machine Pullover",
        preacher_curl_machine: "Preacher Curl Machine",
        standing_biceps_curl_machine: "Standing Biceps Curl Machine",
        arm_curl_machine: "Arm Curl Machine (Biceps Curl Machine)",
        seated_dip_machine: "Seated Dip Machine",
        wrist_curl_machine: "Wrist Curl Machine",
        reverse_wrist_curl_machine: "Reverse Wrist Curl Machine",
        grip_trainer_machine: "Grip Trainer Machine",
        decline_crunch_bench_resistance: "Decline Crunch Bench with Resistance",
        ab_coaster_machine: "Ab Coaster Machine",
        hanging_leg_raise_station: "Hanging Leg Raise Station",
        rotary_torso_machine: "Rotary Torso Machine (Torso Rotation Machine)",
        side_bend_machine: "Side Bend Machine",
        back_extension_machine: "Back Extension Machine",
        seated_low_back_extension_machine: "Seated Low Back Extension Machine",
        seated_leg_raise_machine: "Seated Leg Raise Machine",
        hip_flexor_station: "Hip Flexor Station on Leg Machine",
        hanging_leg_raises_assisted: "Hanging Leg Raises (assisted)",
        glute_kickback_machine: "Glute Kickback Machine",
        sled_leg_press: "Sled Leg Press",
        sissy_squat_machine: "Sissy Squat Machine",
        lying_leg_curl_machine: "Lying Leg Curl Machine (Prone Leg Curl Machine)",
        standing_leg_curl_machine: "Standing Leg Curl Machine",
        glute_ham_raise_machine: "Glute-Ham Raise Machine",
        seated_calf_raise_machine: "Seated Calf Raise Machine",
        leg_press_calf_raise: "Leg Press Calf Raise (Calf Press on Leg Press Machine)",
        donkey_calf_raise_machine: "Donkey Calf Raise Machine",
        incline_machine_press_neutral_grip: "Incline Machine Press with Neutral Grip",
        decline_lever_press: "Decline Lever Press",
        seated_iso_chest_press: "Seated Iso-Chest Press",
        iso_lateral_decline_press: "Iso-Lateral Decline Press",
        machine_hex_press: "Machine Hex Press",
        lever_incline_press: "Lever Incline Press",
        multi_angle_chest_press_machine: "Multi-Angle Chest Press Machine",
        converging_incline_chest_press: "Converging Incline Chest Press",
        leverage_bench_press_machine: "Leverage Bench Press Machine",
        dual_axis_chest_press: "Dual-Axis Chest Press",
        pec_deck_reverse_grip: "Pec Deck Reverse Grip",
        staggered_stance_chest_press: "Staggered-Stance Chest Press",
        isolateral_shoulder_press_machine: "Isolateral Shoulder Press Machine",
        supinated_grip_lat_pulldown: "Supinated Grip Lat Pulldown",
        v_bar_pulldown: "V-Bar Pulldown",
        machine_kneeling_row: "Machine Kneeling Row",
        wide_chest_supported_cable_row: "Wide Chest-Supported Cable Row",
        behind_back_lat_row_machine: "Behind-Back Lat Row Machine",
        hammer_strength_dy_row: "Hammer Strength DY Row",
        bayesian_cable_curl: "Bayesian Cable Curl",
        reverse_grip_triceps_pushdown: "Reverse Grip Triceps Pushdown",
        underhand_triceps_pushdown: "Underhand Triceps Pushdown",
        wrist_rotation_machine: "Wrist Rotation Machine",
        weighted_side_crunch_machine: "Weighted Side Crunch Machine",
        oblique_chop_machine: "Oblique Chop Machine",
        weighted_roman_chair_situps: "Weighted Roman Chair Sit-Ups",
        ab_rotation_machine: "Ab Rotation Machine",
        iso_lateral_back_extension_machine: "Iso-Lateral Back Extension Machine",
        assisted_pistol_squat_machine: "Assisted Pistol Squat Machine",
        standing_calf_raise_machine: "Standing Calf Raise Machine",
        lever_squat_machine: "Lever Squat Machine",
        vertical_leg_press_machine: "Vertical Leg Press Machine",
        glute_drive_machine: "Glute Drive Machine",
        belt_squat_machine: "Belt Squat Machine",
        iso_lateral_row_machine: "Iso-Lateral Row Machine",
        triceps_extension_machine: "Triceps Extension Machine",
        selectorized_back_extension_machine: "Selectorized Back Extension Machine",
        multi_hip_machine: "Multi-Hip Machine",
        medicine_ball_overhead_throw: "Medicine Ball Overhead Throw",
        medicine_ball_shoulder_press_throw: "Medicine Ball Shoulder Press Throw",
        medicine_ball_chest_pass: "Medicine Ball Chest Pass",
        medicine_ball_push_up: "Medicine Ball Push-Up",
        lateral_medicine_ball_throw: "Lateral Medicine Ball Throw",
        medicine_ball_throw: "Medicine Ball Throw",
        medicine_ball_slam: "Medicine Ball Slam",
        medicine_ball_twist: "Medicine Ball Twist",
        kneeling_medicine_ball_throw: "Kneeling Medicine Ball Throw",
        medicine_ball_front_squat: "Medicine Ball Front Squat",
        medicine_ball_reverse_lunge: "Medicine Ball Reverse Lunge",
        medicine_ball_row: "Medicine Ball Bent-Over Row",
        medicine_ball_glute_bridge: "Medicine Ball Glute Bridge",
        medicine_ball_bicep_curl: "Medicine Ball Biceps Curl",
        rotator_cuff_external_rotation: "Rotator Cuff External Rotation",
        rotator_cuff_internal_rotation: "Rotator Cuff Internal Rotation",
        neck_flexion: "Neck Flexion",
        neck_extension: "Neck Extension",
        plate_pinch: "Plate Pinch",
        gripper_work: "Gripper Work",
        tibialis_raise: "Tibialis Raise",
        donkey_calf_raise: "Donkey Calf Raise",
        battle_rope: "Battle Rope",
        pull_over: "Pull Over",
        wrist_roll: "Wrist Roll",
        rotational_curl: "Rotational Curl",
        resistance_band_squat: "Resistance Band Squat",
        resistance_band_leg_curl: "Resistance Band Leg Curl",
        hip_circle_walk: "Hip Circle Walk",
        resistance_band_tricep_pushdown: "Resistance Band Tricep Pushdown",
        ab_wheel_rollout: "Ab Wheel Rollout",
        resistance_band_woodchop: "Resistance Band Woodchop",
        smith_machine_back_squat: "Smith Machine Squat (Back)",
        smith_machine_high_bar_squat: "Smith Machine High-Bar Squat",
        smith_machine_low_bar_squat: "Smith Machine Low-Bar Squat",
        smith_machine_box_squat: "Smith Machine Box Squat",
        smith_machine_front_squat: "Smith Machine Front Squat",
        smith_machine_hack_squat: "Smith Machine Hack Squat",
        smith_machine_sumo_squat: "Smith Machine Sumo Squat",
        smith_machine_zercher_squat: "Smith Machine Zercher Squat",
        smith_machine_split_squat: "Smith Machine Split Squat",
        smith_machine_bulgarian_split_squat: "Smith Machine Bulgarian Split Squat",
        smith_machine_reverse_lunge: "Smith Machine Reverse Lunge",
        smith_machine_forward_lunge: "Smith Machine Lunge (Forward)",
        smith_machine_walking_lunge: "Smith Machine Walking Lunge",
        smith_machine_curtsy_lunge: "Smith Machine Curtsy Lunge",
        smith_machine_lateral_lunge: "Smith Machine Lateral Lunge",
        smith_machine_step_up: "Smith Machine Step-Up",
        smith_machine_pistol_squat_to_box: "Smith Machine Pistol Squat to Box",
        smith_machine_shrimp_squat: "Smith Machine Shrimp Squat",
        smith_machine_good_morning: "Smith Machine Good Morning",
        smith_machine_romanian_deadlift: "Smith Machine Romanian Deadlift (Smith Machine Deadlift)",
        smith_machine_stiff_leg_deadlift: "Smith Machine Stiff-Leg Deadlift",
        smith_machine_single_leg_rdl: "Smith Machine Single-Leg RDL",
        smith_machine_hip_thrust: "Smith Machine Hip Thrust",
        smith_machine_glute_bridge: "Smith Machine Glute Bridge",
        smith_machine_frog_pump: "Smith Machine Frog Pump",
        smith_machine_glute_kickback: "Smith Machine Glute Kickback",
        smith_machine_donkey_kick: "Smith Machine Donkey Kick",
        smith_machine_standing_calf_raise: "Smith Machine Calf Raise (Standing)",
        smith_machine_seated_calf_raise: "Smith Machine Seated Calf Raise",
        smith_machine_single_leg_calf_raise: "Smith Machine Single-Leg Calf Raise",
        smith_machine_calf_press: "Smith Machine Calf Press",
        smith_machine_jefferson_squat: "Smith Machine Jefferson Squat",
        smith_machine_kneeling_squat: "Smith Machine Kneeling Squat",
        smith_machine_skater_squat: "Smith Machine Skater Squat",
        smith_machine_cossack_squat: "Smith Machine Cossack Squat",
        smith_machine_front_foot_elevated_split_squat: "Smith Machine Front-Foot Elevated Split Squat",
        smith_machine_rear_foot_elevated_split_squat: "Smith Machine Rear-Foot Elevated Split Squat",
        smith_machine_split_squat_iso_hold: "Smith Machine Split Squat Iso Hold",
        smith_machine_assisted_nordic_curl: "Smith Machine Assisted Nordic Curl",
        smith_machine_standing_hip_abduction: "Smith Machine Standing Hip Abduction",
        smith_machine_flat_bench_press: "Smith Machine Bench Press (Flat)",
        smith_machine_incline_bench_press: "Smith Machine Incline Bench Press",
        smith_machine_decline_bench_press: "Smith Machine Decline Bench Press",
        smith_machine_close_grip_bench_press: "Smith Machine Close-Grip Bench Press",
        smith_machine_reverse_grip_bench_press: "Smith Machine Reverse-Grip Bench Press",
        smith_machine_floor_press: "Smith Machine Floor Press",
        smith_machine_single_arm_bench_press: "Smith Machine Single-Arm Bench Press",
        smith_machine_guillotine_press: "Smith Machine Guillotine Press",
        smith_machine_shoulder_press: "Smith Machine Shoulder Press",
        smith_machine_behind_neck_press: "Smith Machine Behind-the-Neck Press",
        smith_machine_push_press: "Smith Machine Push Press",
        smith_machine_seated_shoulder_press: "Smith Machine Seated Shoulder Press",
        smith_machine_arnold_press: "Smith Machine Arnold Press",
        smith_machine_upright_row: "Smith Machine Upright Row",
        smith_machine_high_pull: "Smith Machine High Pull",
        smith_machine_shrug: "Smith Machine Shrugs",
        smith_machine_behind_back_shrug: "Smith Machine Behind-the-Back Shrug",
        smith_machine_bent_over_row: "Smith Machine Bent-Over Row",
        smith_machine_pendlay_row: "Smith Machine Pendlay Row",
        smith_machine_underhand_row: "Smith Machine Underhand Row",
        smith_machine_single_arm_row: "Smith Machine Single-Arm Row",
        smith_machine_rack_pull: "Smith Machine Rack Pull",
        smith_machine_seal_row: "Smith Machine Seal Row",
        smith_machine_incline_row: "Smith Machine Incline Row",
        smith_machine_inverted_row: "Smith Machine Inverted Row",
        smith_machine_split_stance_press: "Smith Machine Split-Stance Press",
        smith_machine_standing_chest_press: "Smith Machine Standing Chest Press",
        smith_machine_jammer_press: "Smith Machine Jammer Press",
        smith_machine_iso_lateral_press: "Smith Machine Iso-Lateral Press",
        smith_machine_decline_close_grip_press: "Smith Machine Decline Close-Grip Press",
        smith_machine_board_press: "Smith Machine Board Press",
        smith_machine_triceps_extension: "Smith Machine Triceps Extension",
        smith_machine_jm_press: "Smith Machine JM Press",
        smith_machine_skull_crusher: "Smith Machine Skull Crusher",
        smith_machine_biceps_curl: "Smith Machine Biceps Curl",
        smith_machine_drag_curl: "Smith Machine Drag Curl",
        smith_machine_reverse_curl: "Smith Machine Reverse Curl",
        smith_machine_preacher_curl: "Smith Machine Preacher Curl",
        smith_machine_wrist_curl: "Smith Machine Wrist Curl",
        smith_machine_reverse_wrist_curl: "Smith Machine Reverse Wrist Curl",
        smith_machine_hanging_knee_raise: "Smith Machine Hanging Knee Raise",
        smith_machine_hanging_leg_raise: "Smith Machine Hanging Leg Raise",
        smith_machine_hanging_oblique_raise: "Smith Machine Hanging Oblique Raise",
        smith_machine_hanging_windshield_wiper: "Smith Machine Hanging Windshield Wiper",
        smith_machine_hanging_toes_to_bar: "Smith Machine Hanging Toes-to-Bar",
        smith_machine_l_sit_hold: "Smith Machine L-Sit Hold",
        smith_machine_pike_raise: "Smith Machine Pike Raise",
        smith_machine_hanging_knee_tuck: "Smith Machine Hanging Knee Tuck",
        smith_machine_reverse_crunch: "Smith Machine Reverse Crunch",
        smith_machine_decline_crunch: "Smith Machine Decline Crunch",
        smith_machine_bar_assisted_sit_up: "Smith Machine Bar-Assisted Sit-Up",
        smith_machine_weighted_sit_up: "Smith Machine Weighted Sit-Up",
        smith_machine_crunch_press: "Smith Machine Crunch Press",
        smith_machine_oblique_crunch: "Smith Machine Oblique Crunch",
        smith_machine_side_crunch: "Smith Machine Side Crunch",
        smith_machine_kneeling_ab_rollout: "Smith Machine Kneeling Ab Rollout",
        smith_machine_standing_ab_rollout: "Smith Machine Standing Ab Rollout",
        smith_machine_pike_rollout: "Smith Machine Pike Rollout",
        smith_machine_plank_reach: "Smith Machine Plank Reach",
        smith_machine_mountain_climber: "Smith Machine Mountain Climber",
        smith_machine_body_saw: "Smith Machine Body Saw",
        smith_machine_stir_the_pot: "Smith Machine Stir the Pot",
        smith_machine_dragon_flag: "Smith Machine Dragon Flag",
        smith_machine_hanging_bicycle_crunch: "Smith Machine Hanging Bicycle Crunch",
        smith_machine_hanging_knee_twist: "Smith Machine Hanging Knee Twist",
        smith_machine_dead_bug_press: "Smith Machine Dead Bug Press",
        smith_machine_hollow_body_hold: "Smith Machine Hollow Body Hold",
        smith_machine_plank_row: "Smith Machine Plank Row",
        smith_machine_side_plank: "Smith Machine Side Plank",
        smith_machine_copenhagen_plank: "Smith Machine Copenhagen Plank",
        smith_machine_plank_to_pike: "Smith Machine Plank to Pike",
        smith_machine_shoulder_tap_plank: "Smith Machine Shoulder Tap Plank",
        smith_machine_plank_roll: "Smith Machine Plank Roll",
        smith_machine_bar_jackknife: "Smith Machine Bar Jackknife",
        smith_machine_v_up: "Smith Machine V-Up",
        smith_machine_supine_leg_raise: "Smith Machine Supine Leg Raise",
        smith_machine_toe_tap_crunch: "Smith Machine Toe Tap Crunch",
        smith_machine_oblique_twist: "Smith Machine Oblique Twist",
        smith_machine_plank_walkout: "Smith Machine Plank Walkout",
        smith_machine_overhead_sit_up: "Smith Machine Overhead Sit-Up",
        safety_bar_squat: "Safety Bar Squat",
        trap_bar_deadlift: "Trap Bar/Hex Bar Deadlift",
        ez_bar_curl: "EZ Bar Curl",
        ez_bar_skullcrusher: "EZ Bar Skullcrusher",
        cambered_bar_bench_press: "Cambered Bar Bench Press",
        log_bar_push_press: "Log Bar Push Press",
        zercher_carry: "Zercher Carry",
        },
        log: {
            title: "Log {exercise}",
            backToList: "Back to Muscle Group List",
            noSets: "No sets logged.",
            set: "Set",
            weight: "Weight",
            reps: "Reps",
            repsRequiredTitle: "Reps (required)",
            actions: "Actions",
            delete: "Delete",
            deleteAria: "Delete set",
            clone: "Clone",
            cloneAria: "Clone previous set",
            save: "Save",
            errorPrefix: "Error:",
            dateLabel: "Date:",
            date: "Date",
            lastSessions: "Last {count} Sessions",
            invalidDate: "Please enter a valid date in YYYY-MM-DD format.",
            autosaveFailed:
                "Couldn't auto-save your changes. Please check your browser storage settings.",
            saveFailed:
                "Failed to save your workout data. Please try again or check your browser storage settings.",
            seoTitle: "Log {exercise} | Lightweight Tracker for Sets, Reps & Weights",
            seoDescription: "Log sets, reps, and weight for {exercise} in Gym Tracker.",
        },
        exerciseDetails: {
            title: "Exercise Details",
            equipment: "Equipment:",
            instructions: "Instructions",
            commonMistakes: "Common Mistakes",
            noData: "No detailed information found for this exercise.",
            back: "Back to Log",
            tabMuscles: "Target Muscles",
            tabGuide: "Exercise Guide",
            seoTitle: "{exercise} Instructions & Mistakes | Fit-Log",
            seoDescription: "Learn how to perform {exercise} properly with instructions, equipment, and common mistakes to avoid.",
        },
        auth: {
            navLabel: "Authentication",
            signInUp: "Sign in / Register",
            logout: "Sign out {name}",
            logoutAria: "Sign out",
            signInTitle: "Sign in | Lightweight Tracker for Sets, Reps & Weights",
            signInDescription: "Sign in to Gym Tracker.",
            signUpTitle: "Sign up | Lightweight Tracker for Sets, Reps & Weights",
            signUpDescription: "Create your Gym Tracker account.",
            signInHeading: "Sign in",
            signUpHeading: "Sign up",
        },
        sso: {
            title: "Finishing sign-in | Lightweight Tracker for Sets, Reps & Weights",
            description: "Completing your Gym Tracker sign-in.",
            heading: "Finishing sign-in",
            message: "Finishing sign-in... You will be redirected to the home page shortly.",
        },
        footer: {
            copyright: "© {year} Fit-log.com. All rights reserved.",
        },
        muscleGroups: {
            trapezius: "Trapezius",
            deltoids: "Deltoids",
            rear_deltoids: "Rear Deltoids",
            chest: "Chest",
            upper_back: "Upper Back",
            back: "Back",
            lower_back: "Lower Back",
            biceps: "Biceps",
            triceps: "Triceps",
            forearms: "Forearms",
            abs: "Abs",
            obliques: "Obliques",
            hip_flexors: "Hip Flexors",
            glutes: "Glutes",
            legs: "Legs",
            quadriceps: "Quadriceps",
            hamstrings: "Hamstrings",
            calves: "Calves",
        },
    },
    uk: {
        language: {

                    label: "Мова",

                    english: "English",

                    ukrainian: "Українська",

                },
        common: {

                    na: "Н/Д",

                    appName: "Fit-Log",

                    back: "Назад",

                },
        breadcrumbs: {

                    ariaLabel: "Навігаційний ланцюжок",

                    dashboard: "Панель",

                    selectExercise: "Вибір вправи",

                    createExercise: "Створити вправу",

                    logExerciseSection: "Запис вправи",

                    logExercise: "Запис вправи: {exercise}",

                },
        home: {

                    title: "Записуйте підходи, повторення й вагу",

                    subtitle: "Простий щоденний журнал для силових тренувань.",

                    loggedToday: "Вправи, записані сьогодні",

                    searchExercises: "Пошук вправ",

                    exercise: "Вправа",

                    date: "Дата",

                    setsCount: "Підходи",

                    weight: "Вага",

                    logExercise: "Записати вправу",

                    progressTitle: "Мій прогрес у часі",

                    progressTabsLabel: "Вигляд прогресу",

                    progressByMuscleGroups: "За групами м'язів",

                    progressByDate: "За датою",

                    toggleIndirect: "Показати м'язи з непрямим впливом",

                    toggleIndirectAria: "Перемкнути показ м'язів з непрямим впливом",

                    noData: "Немає даних.",

                    workoutTracker: "Трекер тренувань",

                    exerciseHistoryTable: "Історія вправ за датою",

                    muscleGroup: "Група м'язів",

                    addExerciseFor: "Додати вправу для {group}",

                    emptyStateTitle: "Сьогодні ви ще не записали жодної вправи.",

                    jsonLdDescription: "Fit-Log — легкий трекер для підходів, повторень і ваги. Записуйте вправи та відстежуйте прогрес.",

                    unknownExercise: "Невідома вправа ({id})",

                },
        legend: {

                    direct: "Безпосередньо впливає на групу м'язів",

                    indirect: "Непрямо впливає на групу м'язів",

                },
        select: {

                    title: "Оберіть вправу",

                    titleForMuscle: "Оберіть вправи для {muscle}",

                    createExercise: "Створити вправу",

                    createNewExercise: "Нова вправа",

                    modeRecent: "Нещодавні",

                    modeSearch: "Пошук або створення",

                    modeWizard: "Майстер підбору",

                    modeSwitchAria: "Режим вибору вправи",

                    stepsTitle: "Кроки запису тренування",

                    stepOneNumber: "1",

                    stepOneText: "Оберіть або створіть нову вправу",

                    stepTwoNumber: "2",

                    stepTwoText: "Запишіть ваги та повтори",

                    searchPlaceholder: "Пошук вправи або введення нової назви",

                    searchStartPrompt: "Введіть хоча б одну літеру, щоб почати пошук.",

                    searchTooManyResults: "Уточніть пошук бо забагато вправ",

                    searchCount: "Вправи ({count})",
                    existingExercises: "Вправи",

                    filters: "Фільтри",

                    filtersCount: "Фільтри ({count})",

                    equipment: "Обладнання",

                    equipmentFilterAria: "Фільтр за обладнанням",

                    muscleGroup: "Група м'язів",

                    muscleFilterAria: "Фільтр за групою м'язів",

                    recentExercises: "Нещодавні вправи",

                    otherExercises: "Інші вправи",

                    directExercises: "Прямі вправи",

                    indirectExercises: "Непрямі вправи",

                    noExercisesFound: "Вправ не знайдено.",

                    noRecentExercises: "Немає нещодавніх вправ. Вони з’являться тут після запису.",

                    allExercises: "Усі вправи",

                    equipmentExercises: "Вправи: {equipment}",

                    all: "Усі",

                    seoTitle: "Вправи для {muscle} - Легкий трекер для підходів, повторень і ваги",

                    seoTitleAll: "Вправи - Легкий трекер для підходів, повторень і ваги",

                    seoDescription: "Переглядайте та фільтруйте вправи за обладнанням і групою м'язів, а потім записуйте підходи, повторення та вагу.",

                    seoDescriptionMuscle: "Переглядайте вправи для {muscle} та записуйте підходи, повторення й вагу у Fit-Log.",

                    wizard: {

                        title: "Підберіть вправу по кроках",

                        subtitle: "Дайте кілька коротких відповідей, щоб швидко звузити список.",

                        remaining: "Залишилося {count} вправ",

                        answersLabel: "Обрано",

                        results: "Підходящі вправи",

                        back: "Назад",

                        skip: "Пропустити",

                        reset: "Скинути",

                        noResults: "За цими відповідями вправ не знайдено.",

                        questions: {

                            equipmentFamily: "Що використовується в цій вправі?",

                            implement: "Яка саме вільна вага використовується?",

                            support: "Яка опора або позиція тут є?",

                            movement: "Який це тип руху?",

                            mainArea: "На що основний акцент?",

                        },

                        options: {

                            equipmentFamily: {

                                machine: "Тренажер",

                                cable: "Кросовер",

                                free_weight: "Вільна вага",

                                bodyweight: "Вага тіла",

                                cardio: "Кардіо",

                                other: "Інше",

                            },

                            implement: {

                                barbell: "Гриф",

                                dumbbell: "Гантелі",

                                kettlebell: "Кетлбел",

                                specialty_bar: "Спецгриф",

                                medicine_ball: "М'яч",

                                other: "Інше",

                            },

                            support: {

                                bench: "Лава",

                                seat: "Сидячи",

                                standing: "Стоячи",

                                floor: "Підлога",

                                hanging: "У висі",

                                other: "Інше",

                            },

                            movement: {

                                press: "Жим",

                                pull: "Тяга",

                                squat_or_lunge: "Присід або випад",

                                hinge: "Нахил або hinge",

                                raise_or_curl: "Ізоляція",

                                core_or_carry: "Кор або носіння",

                            },

                            mainArea: {

                                chest: "Груди",

                                back: "Спина",

                                shoulders: "Плечі",

                                legs: "Ноги",

                                arms: "Руки",

                                core: "Кор",

                            },

                        },

                    },

                },
        createExercise: {

                    title: "Створити вправу",

                    backToExercises: "Назад до вправ",

                    nameLabel: "Назва вправи",

                    namePlaceholder: "Введіть назву вправи",

                    primaryMuscleGroup: "Основна група м'язів",

                    save: "Зберегти вправу",

                    saving: "Збереження...",

                    seoTitle: "Створити вправу - Легкий трекер для підходів, повторень і ваги",

                    seoDescription: "Створіть власну вправу, призначте основну групу м'язів і почніть записувати її у Fit-Log.",

                    errorPrefix: "Помилка:",

                    nameRequired: "Будь ласка, введіть назву вправи.",

                    muscleGroupRequired: "Будь ласка, виберіть основну групу м'язів.",

                    duplicateName: "Вправа з такою назвою вже існує.",

                    saveFailed: "Не вдалося зберегти вправу.",

                },
        equipment: {

                    All: "Усі",

                    Barbell: "Штанга",

                    Dumbbell: "Гантелі",

                    Cable: "Блоковий тренажер",

                    Machine: "Тренажер",

                    "Smith Machine": "Машина Сміта",

                    "Specialty Bar": "Спеціальна штанга",

                    Functional: "Функціональні",

                    Kettlebell: "Гирі",

                    "Medicine Ball": "Медбол",

                    Bodyweight: "Власна вага",

                    "Cardio Machine": "Кардіотренажер",

                    Other: "Інше",

                },
        exercises: {

                    bench_press: "Жим лежачи",

                    incline_bench_press: "Жим лежачи на похилій лаві (вгору)",

                    decline_bench_press: "Жим лежачи на похилій лаві (вниз)",

                    squat: "Присідання",

                    front_squat: "Фронтальні присідання",

                    deadlift: "Станова тяга",

                    romanian_deadlift: "Румунська станова тяга",

                    overhead_press: "Жим над головою",

                    barbell_curl: "Підйом штанги на біцепс",

                    close_grip_bench_press: "Жим лежачи вузьким хватом",

                    barbell_shrug: "Шраги зі штангою",

                    barbell_hip_thrust: "Хіп траст зі штангою",

                    barbell_hack_squat: "Хак-присідання зі штангою",

                    zercher_squat: "Присідання Зерчера",

                    barbell_upright_row: "Тяга штанги до підборіддя",

                    barbell_drag_curl: "Barbell Drag Curl",

                    barbell_floor_press: "Жим штанги лежачи на підлозі",

                    barbell_landmine_press: "Лендмайн-жим зі штангою",

                    sumo_squat: "Присідання сумо",

                    good_morning: "Гуд морнінг",

                    push_press: "Пуш-прес",

                    barbell_front_raise: "Підйом штанги перед собою",

                    barbell_behind_the_neck_press: "Жим штанги з-за голови",

                    wide_grip_barbell_row: "Тяга штанги в нахилі широким хватом (лікті в сторони)",

                    reverse_shrug: "Зворотні шраги (акцент на трапеції та задні дельти)",

                    plate_around_the_world: "Around the World з диском (плечі, включно із задніми дельтами)",

                    barbell_side_bend: "Нахили вбік зі штангою",

                    barbell_back_squat: "Присідання зі штангою на спині",

                    barbell_front_squat: "Фронтальні присідання зі штангою",

                    barbell_box_squat: "Присідання зі штангою на бокс",

                    barbell_overhead_squat: "Присідання зі штангою над головою",

                    barbell_romanian_deadlift: "Румунська станова тяга зі штангою",

                    barbell_conventional_deadlift: "Класична станова тяга зі штангою",

                    barbell_sumo_deadlift: "Станова тяга сумо зі штангою",

                    barbell_good_morning: "Гуд морнінг зі штангою",

                    barbell_lunge: "Випади зі штангою",

                    barbell_reverse_lunge: "Зворотні випади зі штангою",

                    barbell_bulgarian_split_squat: "Болгарські спліт-присідання зі штангою",

                    barbell_step_up: "Зашагування на платформу зі штангою",

                    barbell_bench_press: "Жим штанги лежачи",

                    barbell_incline_bench_press: "Жим штанги на похилій лаві (вгору)",

                    barbell_decline_bench_press: "Жим штанги на похилій лаві (вниз)",

                    barbell_close_grip_bench_press: "Жим штанги лежачи вузьким хватом",

                    barbell_overhead_press: "Жим штанги над головою",

                    barbell_push_press: "Пуш-прес зі штангою",

                    barbell_bent_over_row: "Тяга штанги в нахилі",

                    barbell_pendlay_row: "Barbell Pendlay Row",

                    barbell_chest_supported_row: "Тяга штанги з упором грудьми",

                    barbell_biceps_curl: "Згинання рук на біцепс зі штангою",

                    barbell_preacher_curl: "Підйом штанги на лаві Скотта",

                    barbell_skull_crusher: "Французький жим зі штангою лежачи",

                    barbell_glute_bridge: "Сідничний міст зі штангою",

                    barbell_front_rack_lunge: "Випади зі штангою у фронтальній стійці",

                    barbell_zercher_squat: "Присідання Зерчера зі штангою",

                    barbell_power_clean: "Barbell Power Clean",

                    barbell_clean_and_press: "Barbell Clean and Press",

                    barbell_high_pull: "Barbell High Pull",

                    barbell_thruster: "Трастер зі штангою",

                    barbell_rollout: "Barbell Rollout",

                    bodyweight_squat: "Присідання з власною вагою",

                    sumo_squat_bodyweight: "Присідання сумо",

                    jump_squat: "Стрибкові присідання",

                    split_squat_bodyweight: "Спліт-присідання",

                    bulgarian_split_squat_bodyweight: "Болгарські спліт-присідання",

                    walking_lunge: "Випади в ходьбі",

                    reverse_lunge_bodyweight: "Зворотні випади",

                    lateral_lunge_bodyweight: "Бічні випади",

                    curtsy_lunge_bodyweight: "Реверанс-випади",

                    step_up_bodyweight: "Зашагування на платформу",

                    shrimp_squat: "Shrimp Squat",

                    pistol_squat: "Присідання-пістолетик",

                    wall_sit: "Стільчик біля стіни",

                    glute_bridge: "Сідничний міст",

                    single_leg_glute_bridge: "Сідничний міст на одній нозі",

                    hip_thrust_bodyweight: "Хіп траст з власною вагою",

                    glute_bridge_march: "Сідничний міст із почерговим підйомом ніг",

                    hamstring_walkout: "Hamstring Walkout",

                    nordic_curl_assisted: "Assisted Nordic Curl",

                    sliding_leg_curl: "Sliding Leg Curl",

                    single_leg_deadlift_balance: "Single-Leg Deadlift Balance",

                    glute_ham_raise_bodyweight: "Bodyweight Glute-Ham Raise",

                    calf_raise_standing: "Підйом на носки стоячи",

                    single_leg_calf_raise: "Підйом на носок однією ногою",

                    deep_squat_hold: "Утримання в глибокому присіданні",

                    plank: "Планка",

                    side_plank: "Бічна планка",

                    copenhagen_plank: "Копенгагенська планка",

                    side_bridge: "Бічний міст",

                    side_bend: "Нахили вбік",

                    reverse_plank: "Зворотна планка",

                    hollow_body_hold: "Утримання Hollow Body (Hollow Hold)",

                    dead_bug: "Dead Bug",

                    bird_dog: "Bird Dog",

                    superman_hold: "Утримання «Супермен»",

                    lying_leg_raise: "Підйом ніг лежачи",

                    hanging_knee_raise: "Підйом колін у висі",

                    seated_knee_tuck: "Підтягування колін сидячи",

                    bicycle_crunch: "Велосипед",

                    russian_twist: "Російські скручування",

                    lying_windshield_wiper: "Склоочисники лежачи",

                    mountain_climber: "Альпініст",

                    push_up: "Віджимання",

                    pull_up: "Підтягування",

                    chin_up: "Підтягування зворотним хватом",

                    bodyweight_dips: "Віджимання на брусах",

                    burpee: "Берпі",

                    hanging_leg_raise: "Підйом ніг у висі",

                    sit_up: "Підйом корпусу",

                    v_up: "V-Up",

                    back_extension: "Гіперекстензія",

                    inverted_row: "Горизонтальна тяга у висі",

                    pike_push_up: "Віджимання в піку",

                    handstand_push_up: "Віджимання в стійці на руках",

                    bench_triceps_dip: "Зворотні віджимання від лави",

                    bear_crawl: "Ведмежа хода",

                    cable_front_squat: "Cable Front Squat",

                    cable_goblet_squat: "Cable Goblet Squat",

                    cable_sumosquat: "Cable Sumo Squat",

                    cable_split_squat: "Cable Split Squat",

                    cable_bulgarian_split_squat: "Cable Bulgarian Split Squat",

                    cable_reverse_lunge: "Cable Reverse Lunge",

                    cable_curtsy_lunge: "Cable Curtsy Lunge",

                    cable_lateral_lunge: "Cable Lateral Lunge",

                    cable_walking_lunge: "Cable Walking Lunge",

                    cable_step_up: "Cable Step-Up",

                    cable_pistol_squat_assist: "Cable Pistol Squat Assist",

                    cable_single_leg_deadlift: "Cable Single-Leg Deadlift",

                    cable_romanian_deadlift: "Cable Romanian Deadlift",

                    cable_good_morning: "Cable Good Morning",

                    cable_pull_through: "Cable Pull-Through",

                    cable_glute_bridge: "Cable Glute Bridge",

                    cable_hip_thrust: "Cable Hip Thrust",

                    cable_glute_kickback: "Cable Glute Kickback",

                    cable_donkey_kick: "Cable Donkey Kick",

                    cable_fire_hydrant: "Cable Fire Hydrant",

                    cable_standing_hip_abduction: "Cable Standing Hip Abduction",

                    cable_standing_hip_adduction: "Cable Standing Hip Adduction",

                    cable_leg_curl_standing: "Cable Standing Leg Curl",

                    cable_leg_curl_kneeling: "Cable Kneeling Leg Curl",

                    cable_prone_leg_curl: "Cable Prone Leg Curl",

                    cable_standing_calf_raise: "Cable Standing Calf Raise",

                    cable_single_leg_calf_raise: "Cable Single-Leg Calf Raise",

                    cable_seated_calf_raise: "Cable Seated Calf Raise",

                    dual_cable_crunch: "Dual Cable Crunch",

                    cable_kneeling_crunch: "Cable Kneeling Crunch",

                    cable_reverse_crunch: "Cable Reverse Crunch",

                    cable_v_sit_pull: "Cable V-Sit Pull",

                    cable_jackknife: "Cable Jackknife",

                    cable_pallof_press: "Cable Pallof Press",

                    high_pulley_woodchop: "High Pulley Woodchop",

                    low_to_high_cable_woodchop: "Low-to-High Cable Woodchop",

                    cable_oblique_crunch: "Cable Oblique Crunch",

                    cable_side_bend: "Cable Side Bend",

                    cable_anti_rotation_press: "Cable Anti-Rotation Press",

                    cable_back_extension: "Cable Back Extension",

                    cable_crossover: "Cable Crossover",

                    cable_chest_fly: "Cable Chest Fly",

                    cable_incline_fly: "Cable Incline Fly",

                    cable_low_fly: "Cable Low Fly",

                    cable_biceps_curl: "Cable Biceps Curl",

                    cable_rope_hammer_curl: "Cable Rope Hammer Curl",

                    cable_triceps_pushdown: "Cable Triceps Pushdown",

                    cable_overhead_triceps_extension: "Cable Overhead Triceps Extension",

                    cable_face_pull: "Cable Face Pull",

                    cable_lateral_raise: "Cable Lateral Raise",

                    cable_front_raise: "Cable Front Raise",

                    cable_upright_row: "Cable Upright Row",

                    cable_row: "Cable Row",

                    cable_seated_row: "Seated Cable Row",

                    cable_lat_pulldown: "Cable Lat Pulldown",

                    cable_straight_arm_pulldown: "Cable Straight-Arm Pulldown",

                    cable_woodchopper: "Cable Woodchopper",

                    cable_reverse_woodchopper: "Cable Reverse Woodchopper",

                    cable_crunch: "Cable Crunch",

                    cable_kickback_triceps: "Cable Kickback (Triceps)",

                    cable_single_arm_row: "Cable Single-Arm Row",

                    cable_rear_delt_fly: "Cable Rear Delt Fly",

                    treadmill: "Бігова доріжка",

                    elliptical_trainer: "Еліптичний тренажер (крос-тренажер)",

                    upright_bike: "Вертикальний велотренажер",

                    recumbent_bike: "Горизонтальний велотренажер",

                    spin_bike: "Сайкл / спін-байк",

                    rowing_machine: "Гребний тренажер",

                    stair_climber: "Сходовий тренажер / степміл",

                    skierg: "SkiErg",

                    bikeerg: "BikeErg",

                    arc_trainer: "Arc Trainer",

                    curved_treadmill: "Механічна вигнута бігова доріжка (Air Runner)",

                    vertical_climber: "VersaClimber / Vertical Climber",

                    adaptive_motion_trainer: "Adaptive Motion Trainer (AMT)",

                    recumbent_stepper: "Горизонтальний степер",

                    hybrid_row_bike: "Hybrid Row-Bike Machine",

                    assault_bike: "AirDyne / Assault Bike",

                    battle_ropes_station: "Станція для battle ropes",

                    sled_push_track: "Доріжка для штовхання саней",

                    skillmill: "SkillMill / Motorized Non-Electric Runner",

                    vibration_plate: "Віброплатформа",

                    climbing_wall_simulator: "Симулятор скеледрому",

                    hydraulic_rower: "Hydraulic Rowers / Resistance Trainers",

                    cardio_boxing_machine: "Кардіо-боксерські тренажери",

                    digital_interactive_trainer: "Digital Interactive Trainer",

                    recovery_boots: "Recovery Boots / Compression Therapy Station",

                    swimming: "Swimming (especially freestyle and butterfly)",

                    cross_country_skiing: "Cross-Country Skiing",

                    boxing_punching: "Boxing/Punching",

                    jump_rope: "Jump Rope",

                    indoor_track: "Indoor Track",

                    dumbbell_front_squat: "Dumbbell Front Squat",

                    dumbbell_goblet_squat: "Dumbbell Goblet Squat",

                    dumbbell_back_squat: "Dumbbell Back Squat",

                    dumbbell_sumosquat: "Dumbbell Sumo Squat",

                    dumbbell_split_squat: "Dumbbell Split Squat",

                    dumbbell_bulgarian_split_squat: "Dumbbell Bulgarian Split Squat",

                    dumbbell_reverse_lunge: "Dumbbell Reverse Lunge",

                    dumbbell_forward_lunge: "Dumbbell Forward Lunge",

                    dumbbell_lateral_lunge: "Dumbbell Lateral Lunge",

                    dumbbell_curtsy_lunge: "Dumbbell Curtsy Lunge",

                    dumbbell_step_up: "Dumbbell Step-Up",

                    dumbbell_box_step_down: "Dumbbell Box Step-Down",

                    dumbbell_cossack_squat: "Dumbbell Cossack Squat",

                    dumbbell_suitcase_squat: "Dumbbell Suitcase Squat",

                    dumbbell_kneeling_squat: "Dumbbell Kneeling Squat",

                    dumbbell_lunge_high_knee: "Dumbbell Lunge to High Knee",

                    dumbbell_lunge_to_reverse: "Dumbbell Forward-Backward Lunge",

                    dumbbell_single_leg_deadlift: "Dumbbell Single-Leg Deadlift",

                    dumbbell_romanian_deadlift: "Dumbbell Romanian Deadlift",

                    dumbbell_stiff_leg_deadlift: "Dumbbell Stiff-Leg Deadlift",

                    dumbbell_suitcase_deadlift: "Dumbbell Suitcase Deadlift",

                    dumbbell_good_morning: "Dumbbell Good Morning",

                    dumbbell_swing: "Dumbbell Swing",

                    dumbbell_glute_bridge: "Dumbbell Glute Bridge",

                    dumbbell_single_leg_glute_bridge: "Dumbbell Single-Leg Glute Bridge",

                    dumbbell_hip_thrust: "Dumbbell Hip Thrust",

                    dumbbell_hamstring_bridge: "Dumbbell Hamstring Bridge",

                    dumbbell_glute_kickback: "Dumbbell Glute Kickback",

                    dumbbell_donkey_kick: "Dumbbell Donkey Kick",

                    dumbbell_fire_hydrant: "Dumbbell Fire Hydrant",

                    dumbbell_lateral_leg_raise: "Dumbbell Lateral Leg Raise",

                    dumbbell_standing_calf_raise: "Dumbbell Standing Calf Raise",

                    dumbbell_single_leg_calf_raise: "Dumbbell Single-Leg Calf Raise",

                    dumbbell_seated_calf_raise: "Dumbbell Seated Calf Raise",

                    dumbbell_side_bend: "Dumbbell Side Bend",

                    dumbbell_russian_twist: "Dumbbell Russian Twist",

                    dumbbell_v_sit_press: "Dumbbell V-Sit Press",

                    dumbbell_dead_bug: "Dumbbell Dead Bug",

                    dumbbell_reverse_crunch: "Dumbbell Reverse Crunch",

                    dumbbell_woodchop: "Dumbbell Woodchop",

                    dumbbell_pallof_press: "Dumbbell Pallof Press",

                    dumbbell_plank_row: "Dumbbell Plank Row",

                    dumbbell_suitcase_carry: "Dumbbell Suitcase Carry",

                    dumbbell_farmer_carry: "Dumbbell Farmer Carry",

                    dumbbell_bench_press: "Dumbbell Bench Press",

                    dumbbell_incline_bench_press: "Dumbbell Incline Bench Press",

                    dumbbell_decline_bench_press: "Dumbbell Decline Bench Press",

                    dumbbell_shoulder_press: "Dumbbell Shoulder Press",

                    dumbbell_arnold_press: "Dumbbell Arnold Press",

                    dumbbell_lateral_raise: "Dumbbell Lateral Raise",

                    dumbbell_front_raise: "Dumbbell Front Raise",

                    dumbbell_y_raise: "Dumbbell Y Raise",

                    dumbbell_rear_delt_fly: "Dumbbell Rear Delt Fly",

                    dumbbell_bent_over_row: "Dumbbell Bent-Over Row",

                    dumbbell_single_arm_bench_row: "Dumbbell Single-Arm Bench Row",

                    dumbbell_chest_fly: "Dumbbell Chest Fly",

                    dumbbell_incline_chest_fly: "Dumbbell Incline Chest Fly",

                    dumbbell_lunge: "Dumbbell Lunge",

                    dumbbell_hammer_curl: "Dumbbell Hammer Curl",

                    dumbbell_biceps_curl: "Dumbbell Biceps Curl",

                    dumbbell_concentration_curl: "Dumbbell Concentration Curl",

                    dumbbell_triceps_kickback: "Dumbbell Triceps Kickback",

                    dumbbell_overhead_triceps_extension: "Dumbbell Overhead Triceps Extension",

                    dumbbell_chest_supported_row: "Dumbbell Chest-Supported Row",

                    dumbbell_shrug: "Dumbbell Shrug",

                    dumbbell_floor_press: "Dumbbell Floor Press",

                    dumbbell_pullover: "Dumbbell Pullover",

                    thrusters: "Thrusters",

                    push_jerk: "Push Jerk",

                    clean_and_press: "Clean and Press",

                    sandbag_clean_and_press: "Sandbag Clean and Press",

                    landmine_press: "Landmine Press",

                    landmine_rotations: "Landmine Rotations",

                    sled_push: "Sled Push",

                    sled_pull: "Sled Pull",

                    prowler_push: "Prowler Push",

                    tire_flips: "Tire Flips",

                    sandbag_carry: "Sandbag Carry",

                    sandbag_clean: "Sandbag Clean",

                    sandbag_squat: "Sandbag Squat",

                    sandbag_floor_press: "Sandbag Floor Press",

                    kettlebell_deadlift: "Kettlebell Deadlift",

                    kettlebell_squat: "Kettlebell Squat",

                    kettlebell_swing: "Kettlebell Swing",

                    kettlebell_overhead_press: "Kettlebell Overhead Press",

                    kettlebell_arnold_press: "Kettlebell Arnold Press",

                    kettlebell_lateral_raise: "Kettlebell Lateral Raise",

                    kettlebell_upright_row: "Kettlebell Upright Row",

                    kettlebell_halo: "Kettlebell Halo",

                    bottoms_up_kettlebell_press: "Bottoms-Up Kettlebell Press",

                    turkish_get_up: "Turkish Get-Up",

                    kettlebell_clean: "Kettlebell Clean",

                    kettlebell_rear_delt_swing: "Kettlebell Rear Delt Swing",

                    bent_over_kettlebell_fly: "Bent-Over Kettlebell Fly",

                    kettlebell_high_pull: "Kettlebell High Pull (elbows out)",

                    bottoms_up_kettlebell_row: "Bottoms-Up Kettlebell Row",

                    kettlebell_floor_press: "Kettlebell Floor Press",

                    kettlebell_windmill: "Kettlebell Windmill",

                    chest_fly_machine_dual_adjustable: "Chest Fly Machine (Dual Adjustable)",

                    converging_chest_press_machine: "Converging Chest Press Machine",

                    iso_lateral_chest_press: "Iso-Lateral Chest Press (Hammer Strength Chest Press)",

                    vertical_chest_press_machine: "Vertical Chest Press Machine",

                    lever_chest_press: "Lever Chest Press",

                    plate_loaded_chest_fly: "Plate-Loaded Chest Fly",

                    incline_lever_chest_press: "Incline Lever Chest Press (Hammer Strength Incline Press)",

                    assisted_chest_dips: "Assisted Chest Dips",

                    iso_lateral_shoulder_press: "Iso-Lateral Shoulder Press (Hammer Strength Shoulder Press)",

                    lever_shoulder_press: "Lever Shoulder Press",

                    machine_front_raise: "Machine Front Raise",

                    spider_curl_machine: "Spider Curl Machine",

                    triceps_dips_assisted_machine: "Assisted Dip Machine (Triceps Dips)",

                    wrist_extension_machine: "Wrist Extension on Cable Machine",

                    oblique_twists_machine: "Oblique Twists on Cable Machine",

                    reverse_crunch_machine: "Reverse Crunch on Cable Machine",

                    machine_good_mornings: "Machine Good Mornings",

                    forty_five_degree_back_extension: "45-Degree Back Extension Machine",

                    roman_chair_hyperextension: "Roman Chair Hyperextension",

                    standing_hip_abduction_machine: "Standing Hip Abduction Machine",

                    seated_hip_abduction_machine: "Seated Hip Abduction Machine",

                    seated_hip_adduction_machine: "Seated Hip Adduction Machine",

                    meadow_row_machine: "Meadow Row Machine",

                    dead_row_machine: "Dead Row Machine",

                    iso_lateral_high_row: "Iso-Lateral High Row",

                    one_arm_high_pulley_row: "One Arm High Pulley Row",

                    single_arm_seated_row: "Single Arm Seated Row",

                    underhand_lat_pulldown: "Underhand Lat Pulldown",

                    behind_the_neck_lat_pulldown: "Behind-the-Neck Lat Pulldown",

                    unilateral_lat_pulldown: "Unilateral Lat Pulldown",

                    plate_loaded_lat_pulldown: "Plate-Loaded Lat Pulldown (Hammer Strength Pulldown, Plate-Loaded Pulldown, Iso-Lateral Pulldown Machine)",

                    reverse_pec_deck: "Reverse Pec Deck (Rear Delt Fly Machine / Pec Deck/Rear Delt Combo Machine)",

                    reverse_machine_shoulder_press: "Reverse Machine Shoulder Press (leaning forward)",

                    rear_delt_row_seated_machine: "Rear Delt Row on Seated Row Machine",

                    wide_grip_assisted_pullup: "Assisted Pull-Up (wide grip, leaning back)",

                    high_row_machine: "High Row Machine (elbows flared, Hammer Strength High Row)",

                    side_hyperextension: "Side Hyperextension",

                    weighted_side_hyperextension: "Weighted Side Hyperextension",

                    lateral_flexion_machine: "Lateral Flexion Machine",

                    machine_row: "Machine Row",

                    shoulder_press_machine: "Shoulder Press Machine",

                    cable_crossover_machine: "Cable Crossover Machine",

                    functional_trainer: "Functional Trainer / Dual Pulley Station (Dual Adjustable Pulley Machine)",

                    ab_crunch_machine: "Ab Crunch Machine",

                    glute_bridge_machine: "Glute Bridge / Hip Thrust Machine",

                    back_extension_bench: "Back Extension / Hyperextension Bench",

                    multi_gym_station: "Multi-gym Selectorized Station",

                    face_pull_station: "Face Pull / Rope Crossover Station",

                    plate_loaded_shoulder_press: "Plate-loaded Shoulder Press",

                    plate_loaded_chest_press: "Plate-loaded Chest Press",

                    plate_loaded_row_machine: "Plate-loaded Row Machine",

                    machine_press: "Machine Press",

                    machine_curl: "Machine Curl",

                    machine_tricep_pushdown: "Machine Tricep Pushdown",

                    machine_leg_extension: "Machine Leg Extension",

                    machine_leg_curl: "Machine Leg Curl (Seated Leg Curl Machine)",

                    machine_calf_raise: "Machine Calf Raise",

                    hack_squat_machine: "Hack Squat Machine (Linear Hack Squat Machine)",

                    pec_deck: "Pec Deck/Butterfly Machine (Pec Deck Machine)",

                    seated_row_machine: "Seated Row Machine",

                    abductor_machine: "Abductor Machine (Outer Thigh Machine / Hip Abductor Machine)",

                    adductor_machine: "Adductor Machine (Inner Thigh Machine / Hip Adductor Machine)",

                    reverse_hyperextension_machine: "Reverse Hyperextension Machine",

                    assisted_pull_up_machine: "Assisted Pull-up Machine",

                    assisted_dip_machine: "Assisted Dip Machine",

                    leg_press: "Leg Press",

                    lat_pulldown: "Lat Pulldown Machine",

                    leg_curl: "Leg Curl",

                    leg_extension: "Leg Extension",

                    lateral_raise_machine: "Lateral Raise Machine (Selectorized / Lateral Raise Selectorized Machine)",

                    reverse_fly_machine: "Reverse Fly Machine / Rear Delt Machine",

                    shrug_machine: "Shrug Machine",

                    seated_row_elevated_scapula_pull: "Seated Row Machine with Elevated Scapula Pull",

                    chest_press_machine: "Chest Press Machine",

                    incline_chest_press_machine: "Incline Chest Press Machine",

                    decline_chest_press_machine: "Decline Chest Press Machine",

                    seated_cable_chest_press: "Seated Cable Chest Press",

                    lat_pulldown_wide_grip: "Lat Pulldown (wide grip)",

                    seated_row_machine_wide_grip: "Seated Row Machine (wide grip)",

                    cable_high_row: "Cable High Row",

                    lat_pulldown_neutral_grip: "Lat Pulldown (neutral grip)",

                    close_grip_seated_row: "Close-Grip Seated Row",

                    hammer_strength_row: "Hammer Strength Row",

                    machine_pullover: "Machine Pullover",

                    preacher_curl_machine: "Preacher Curl Machine",

                    standing_biceps_curl_machine: "Standing Biceps Curl Machine",

                    arm_curl_machine: "Arm Curl Machine (Biceps Curl Machine)",

                    seated_dip_machine: "Seated Dip Machine",

                    wrist_curl_machine: "Wrist Curl Machine",

                    reverse_wrist_curl_machine: "Reverse Wrist Curl Machine",

                    grip_trainer_machine: "Grip Trainer Machine",

                    decline_crunch_bench_resistance: "Decline Crunch Bench with Resistance",

                    ab_coaster_machine: "Ab Coaster Machine",

                    hanging_leg_raise_station: "Hanging Leg Raise Station",

                    rotary_torso_machine: "Rotary Torso Machine (Torso Rotation Machine)",

                    side_bend_machine: "Side Bend Machine",

                    back_extension_machine: "Back Extension Machine",

                    seated_low_back_extension_machine: "Seated Low Back Extension Machine",

                    seated_leg_raise_machine: "Seated Leg Raise Machine",

                    hip_flexor_station: "Hip Flexor Station on Leg Machine",

                    hanging_leg_raises_assisted: "Hanging Leg Raises (assisted)",

                    glute_kickback_machine: "Glute Kickback Machine",

                    sled_leg_press: "Sled Leg Press",

                    sissy_squat_machine: "Sissy Squat Machine",

                    lying_leg_curl_machine: "Lying Leg Curl Machine (Prone Leg Curl Machine)",

                    standing_leg_curl_machine: "Standing Leg Curl Machine",

                    glute_ham_raise_machine: "Glute-Ham Raise Machine",

                    seated_calf_raise_machine: "Seated Calf Raise Machine",

                    leg_press_calf_raise: "Leg Press Calf Raise (Calf Press on Leg Press Machine)",

                    donkey_calf_raise_machine: "Donkey Calf Raise Machine",

                    incline_machine_press_neutral_grip: "Incline Machine Press with Neutral Grip",

                    decline_lever_press: "Decline Lever Press",

                    seated_iso_chest_press: "Seated Iso-Chest Press",

                    iso_lateral_decline_press: "Iso-Lateral Decline Press",

                    machine_hex_press: "Machine Hex Press",

                    lever_incline_press: "Lever Incline Press",

                    multi_angle_chest_press_machine: "Multi-Angle Chest Press Machine",

                    converging_incline_chest_press: "Converging Incline Chest Press",

                    leverage_bench_press_machine: "Leverage Bench Press Machine",

                    dual_axis_chest_press: "Dual-Axis Chest Press",

                    pec_deck_reverse_grip: "Pec Deck Reverse Grip",

                    staggered_stance_chest_press: "Staggered-Stance Chest Press",

                    isolateral_shoulder_press_machine: "Isolateral Shoulder Press Machine",

                    supinated_grip_lat_pulldown: "Supinated Grip Lat Pulldown",

                    v_bar_pulldown: "V-Bar Pulldown",

                    machine_kneeling_row: "Machine Kneeling Row",

                    wide_chest_supported_cable_row: "Wide Chest-Supported Cable Row",

                    behind_back_lat_row_machine: "Behind-Back Lat Row Machine",

                    hammer_strength_dy_row: "Hammer Strength DY Row",

                    bayesian_cable_curl: "Bayesian Cable Curl",

                    reverse_grip_triceps_pushdown: "Reverse Grip Triceps Pushdown",

                    underhand_triceps_pushdown: "Underhand Triceps Pushdown",

                    wrist_rotation_machine: "Wrist Rotation Machine",

                    weighted_side_crunch_machine: "Weighted Side Crunch Machine",

                    oblique_chop_machine: "Oblique Chop Machine",

                    weighted_roman_chair_situps: "Weighted Roman Chair Sit-Ups",

                    ab_rotation_machine: "Ab Rotation Machine",

                    iso_lateral_back_extension_machine: "Iso-Lateral Back Extension Machine",

                    assisted_pistol_squat_machine: "Assisted Pistol Squat Machine",

                    standing_calf_raise_machine: "Standing Calf Raise Machine",

                    lever_squat_machine: "Lever Squat Machine",

                    vertical_leg_press_machine: "Vertical Leg Press Machine",

                    glute_drive_machine: "Glute Drive Machine",

                    belt_squat_machine: "Belt Squat Machine",

                    iso_lateral_row_machine: "Iso-Lateral Row Machine",

                    triceps_extension_machine: "Triceps Extension Machine",

                    selectorized_back_extension_machine: "Selectorized Back Extension Machine",

                    multi_hip_machine: "Multi-Hip Machine",

                    medicine_ball_overhead_throw: "Medicine Ball Overhead Throw",

                    medicine_ball_shoulder_press_throw: "Medicine Ball Shoulder Press Throw",

                    medicine_ball_chest_pass: "Medicine Ball Chest Pass",

                    medicine_ball_push_up: "Medicine Ball Push-Up",

                    lateral_medicine_ball_throw: "Lateral Medicine Ball Throw",

                    medicine_ball_throw: "Medicine Ball Throw",

                    medicine_ball_slam: "Medicine Ball Slam",

                    medicine_ball_twist: "Medicine Ball Twist",

                    kneeling_medicine_ball_throw: "Kneeling Medicine Ball Throw",

                    medicine_ball_front_squat: "Medicine Ball Front Squat",

                    medicine_ball_reverse_lunge: "Medicine Ball Reverse Lunge",

                    medicine_ball_row: "Medicine Ball Bent-Over Row",

                    medicine_ball_glute_bridge: "Medicine Ball Glute Bridge",

                    medicine_ball_bicep_curl: "Medicine Ball Biceps Curl",

                    rotator_cuff_external_rotation: "Rotator Cuff External Rotation",

                    rotator_cuff_internal_rotation: "Rotator Cuff Internal Rotation",

                    neck_flexion: "Neck Flexion",

                    neck_extension: "Neck Extension",

                    plate_pinch: "Plate Pinch",

                    gripper_work: "Gripper Work",

                    tibialis_raise: "Tibialis Raise",

                    donkey_calf_raise: "Donkey Calf Raise",

                    battle_rope: "Battle Rope",

                    pull_over: "Pull Over",

                    wrist_roll: "Wrist Roll",

                    rotational_curl: "Rotational Curl",

                    resistance_band_squat: "Resistance Band Squat",

                    resistance_band_leg_curl: "Resistance Band Leg Curl",

                    hip_circle_walk: "Hip Circle Walk",

                    resistance_band_tricep_pushdown: "Resistance Band Tricep Pushdown",

                    ab_wheel_rollout: "Ab Wheel Rollout",

                    resistance_band_woodchop: "Resistance Band Woodchop",

                    smith_machine_back_squat: "Smith Machine Squat (Back)",

                    smith_machine_high_bar_squat: "Smith Machine High-Bar Squat",

                    smith_machine_low_bar_squat: "Smith Machine Low-Bar Squat",

                    smith_machine_box_squat: "Smith Machine Box Squat",

                    smith_machine_front_squat: "Smith Machine Front Squat",

                    smith_machine_hack_squat: "Smith Machine Hack Squat",

                    smith_machine_sumo_squat: "Smith Machine Sumo Squat",

                    smith_machine_zercher_squat: "Smith Machine Zercher Squat",

                    smith_machine_split_squat: "Smith Machine Split Squat",

                    smith_machine_bulgarian_split_squat: "Smith Machine Bulgarian Split Squat",

                    smith_machine_reverse_lunge: "Smith Machine Reverse Lunge",

                    smith_machine_forward_lunge: "Smith Machine Lunge (Forward)",

                    smith_machine_walking_lunge: "Smith Machine Walking Lunge",

                    smith_machine_curtsy_lunge: "Smith Machine Curtsy Lunge",

                    smith_machine_lateral_lunge: "Smith Machine Lateral Lunge",

                    smith_machine_step_up: "Smith Machine Step-Up",

                    smith_machine_pistol_squat_to_box: "Smith Machine Pistol Squat to Box",

                    smith_machine_shrimp_squat: "Smith Machine Shrimp Squat",

                    smith_machine_good_morning: "Smith Machine Good Morning",

                    smith_machine_romanian_deadlift: "Smith Machine Romanian Deadlift (Smith Machine Deadlift)",

                    smith_machine_stiff_leg_deadlift: "Smith Machine Stiff-Leg Deadlift",

                    smith_machine_single_leg_rdl: "Smith Machine Single-Leg RDL",

                    smith_machine_hip_thrust: "Smith Machine Hip Thrust",

                    smith_machine_glute_bridge: "Smith Machine Glute Bridge",

                    smith_machine_frog_pump: "Smith Machine Frog Pump",

                    smith_machine_glute_kickback: "Smith Machine Glute Kickback",

                    smith_machine_donkey_kick: "Smith Machine Donkey Kick",

                    smith_machine_standing_calf_raise: "Smith Machine Calf Raise (Standing)",

                    smith_machine_seated_calf_raise: "Smith Machine Seated Calf Raise",

                    smith_machine_single_leg_calf_raise: "Smith Machine Single-Leg Calf Raise",

                    smith_machine_calf_press: "Smith Machine Calf Press",

                    smith_machine_jefferson_squat: "Smith Machine Jefferson Squat",

                    smith_machine_kneeling_squat: "Smith Machine Kneeling Squat",

                    smith_machine_skater_squat: "Smith Machine Skater Squat",

                    smith_machine_cossack_squat: "Smith Machine Cossack Squat",

                    smith_machine_front_foot_elevated_split_squat: "Smith Machine Front-Foot Elevated Split Squat",

                    smith_machine_rear_foot_elevated_split_squat: "Smith Machine Rear-Foot Elevated Split Squat",

                    smith_machine_split_squat_iso_hold: "Smith Machine Split Squat Iso Hold",

                    smith_machine_assisted_nordic_curl: "Smith Machine Assisted Nordic Curl",

                    smith_machine_standing_hip_abduction: "Smith Machine Standing Hip Abduction",

                    smith_machine_flat_bench_press: "Smith Machine Bench Press (Flat)",

                    smith_machine_incline_bench_press: "Smith Machine Incline Bench Press",

                    smith_machine_decline_bench_press: "Smith Machine Decline Bench Press",

                    smith_machine_close_grip_bench_press: "Smith Machine Close-Grip Bench Press",

                    smith_machine_reverse_grip_bench_press: "Smith Machine Reverse-Grip Bench Press",

                    smith_machine_floor_press: "Smith Machine Floor Press",

                    smith_machine_single_arm_bench_press: "Smith Machine Single-Arm Bench Press",

                    smith_machine_guillotine_press: "Smith Machine Guillotine Press",

                    smith_machine_shoulder_press: "Smith Machine Shoulder Press",

                    smith_machine_behind_neck_press: "Smith Machine Behind-the-Neck Press",

                    smith_machine_push_press: "Smith Machine Push Press",

                    smith_machine_seated_shoulder_press: "Smith Machine Seated Shoulder Press",

                    smith_machine_arnold_press: "Smith Machine Arnold Press",

                    smith_machine_upright_row: "Smith Machine Upright Row",

                    smith_machine_high_pull: "Smith Machine High Pull",

                    smith_machine_shrug: "Smith Machine Shrugs",

                    smith_machine_behind_back_shrug: "Smith Machine Behind-the-Back Shrug",

                    smith_machine_bent_over_row: "Smith Machine Bent-Over Row",

                    smith_machine_pendlay_row: "Smith Machine Pendlay Row",

                    smith_machine_underhand_row: "Smith Machine Underhand Row",

                    smith_machine_single_arm_row: "Smith Machine Single-Arm Row",

                    smith_machine_rack_pull: "Smith Machine Rack Pull",

                    smith_machine_seal_row: "Smith Machine Seal Row",

                    smith_machine_incline_row: "Smith Machine Incline Row",

                    smith_machine_inverted_row: "Smith Machine Inverted Row",

                    smith_machine_split_stance_press: "Smith Machine Split-Stance Press",

                    smith_machine_standing_chest_press: "Smith Machine Standing Chest Press",

                    smith_machine_jammer_press: "Smith Machine Jammer Press",

                    smith_machine_iso_lateral_press: "Smith Machine Iso-Lateral Press",

                    smith_machine_decline_close_grip_press: "Smith Machine Decline Close-Grip Press",

                    smith_machine_board_press: "Smith Machine Board Press",

                    smith_machine_triceps_extension: "Smith Machine Triceps Extension",

                    smith_machine_jm_press: "Smith Machine JM Press",

                    smith_machine_skull_crusher: "Smith Machine Skull Crusher",

                    smith_machine_biceps_curl: "Smith Machine Biceps Curl",

                    smith_machine_drag_curl: "Smith Machine Drag Curl",

                    smith_machine_reverse_curl: "Smith Machine Reverse Curl",

                    smith_machine_preacher_curl: "Smith Machine Preacher Curl",

                    smith_machine_wrist_curl: "Smith Machine Wrist Curl",

                    smith_machine_reverse_wrist_curl: "Smith Machine Reverse Wrist Curl",

                    smith_machine_hanging_knee_raise: "Smith Machine Hanging Knee Raise",

                    smith_machine_hanging_leg_raise: "Smith Machine Hanging Leg Raise",

                    smith_machine_hanging_oblique_raise: "Smith Machine Hanging Oblique Raise",

                    smith_machine_hanging_windshield_wiper: "Smith Machine Hanging Windshield Wiper",

                    smith_machine_hanging_toes_to_bar: "Smith Machine Hanging Toes-to-Bar",

                    smith_machine_l_sit_hold: "Smith Machine L-Sit Hold",

                    smith_machine_pike_raise: "Smith Machine Pike Raise",

                    smith_machine_hanging_knee_tuck: "Smith Machine Hanging Knee Tuck",

                    smith_machine_reverse_crunch: "Smith Machine Reverse Crunch",

                    smith_machine_decline_crunch: "Smith Machine Decline Crunch",

                    smith_machine_bar_assisted_sit_up: "Smith Machine Bar-Assisted Sit-Up",

                    smith_machine_weighted_sit_up: "Smith Machine Weighted Sit-Up",

                    smith_machine_crunch_press: "Smith Machine Crunch Press",

                    smith_machine_oblique_crunch: "Smith Machine Oblique Crunch",

                    smith_machine_side_crunch: "Smith Machine Side Crunch",

                    smith_machine_kneeling_ab_rollout: "Smith Machine Kneeling Ab Rollout",

                    smith_machine_standing_ab_rollout: "Smith Machine Standing Ab Rollout",

                    smith_machine_pike_rollout: "Smith Machine Pike Rollout",

                    smith_machine_plank_reach: "Smith Machine Plank Reach",

                    smith_machine_mountain_climber: "Smith Machine Mountain Climber",

                    smith_machine_body_saw: "Smith Machine Body Saw",

                    smith_machine_stir_the_pot: "Smith Machine Stir the Pot",

                    smith_machine_dragon_flag: "Smith Machine Dragon Flag",

                    smith_machine_hanging_bicycle_crunch: "Smith Machine Hanging Bicycle Crunch",

                    smith_machine_hanging_knee_twist: "Smith Machine Hanging Knee Twist",

                    smith_machine_dead_bug_press: "Smith Machine Dead Bug Press",

                    smith_machine_hollow_body_hold: "Smith Machine Hollow Body Hold",

                    smith_machine_plank_row: "Smith Machine Plank Row",

                    smith_machine_side_plank: "Smith Machine Side Plank",

                    smith_machine_copenhagen_plank: "Smith Machine Copenhagen Plank",

                    smith_machine_plank_to_pike: "Smith Machine Plank to Pike",

                    smith_machine_shoulder_tap_plank: "Smith Machine Shoulder Tap Plank",

                    smith_machine_plank_roll: "Smith Machine Plank Roll",

                    smith_machine_bar_jackknife: "Smith Machine Bar Jackknife",

                    smith_machine_v_up: "Smith Machine V-Up",

                    smith_machine_supine_leg_raise: "Smith Machine Supine Leg Raise",

                    smith_machine_toe_tap_crunch: "Smith Machine Toe Tap Crunch",

                    smith_machine_oblique_twist: "Smith Machine Oblique Twist",

                    smith_machine_plank_walkout: "Smith Machine Plank Walkout",

                    smith_machine_overhead_sit_up: "Smith Machine Overhead Sit-Up",

                    safety_bar_squat: "Safety Bar Squat",

                    trap_bar_deadlift: "Trap Bar/Hex Bar Deadlift",

                    ez_bar_curl: "EZ Bar Curl",

                    ez_bar_skullcrusher: "EZ Bar Skullcrusher",

                    cambered_bar_bench_press: "Cambered Bar Bench Press",

                    log_bar_push_press: "Log Bar Push Press",

                    zercher_carry: "Zercher Carry",

                },
        log: {

                    title: "Записати {exercise}",

                    backToList: "Назад до списку груп м'язів",

                    noSets: "Немає записаних підходів.",

                    set: "Підхід",

                    weight: "Вага",

                    reps: "Повторення",

                    repsRequiredTitle: "Повторення (обов'язково)",

                    actions: "Дії",

                    delete: "Видалити",

                    deleteAria: "Видалити підхід",

                    clone: "Клонувати",

                    cloneAria: "Клонувати попередній підхід",

                    save: "Зберегти",

                    errorPrefix: "Помилка:",

                    dateLabel: "Дата:",

                    date: "Дата",

                    lastSessions: "Останні {count} сесій",

                    invalidDate: "Введіть коректну дату у форматі YYYY-MM-DD.",

                    autosaveFailed: "Не вдалося автозберегти зміни. Перевірте налаштування сховища браузера.",

                    saveFailed: "Не вдалося зберегти дані тренування. Спробуйте ще раз або перевірте сховище браузера.",

                    seoTitle: "Записати {exercise} | Легкий трекер для підходів, повторень і ваги",

                    seoDescription: "Записуйте підходи, повторення та вагу для {exercise} у Fit-Log.",

                },
        exerciseDetails: {
            title: "Деталі вправи",
            equipment: "Обладнання:",
            instructions: "Інструкції",
            commonMistakes: "Часті помилки",
            noData: "Інформацію про цю вправу не знайдено.",
            back: "Назад до запису",
            tabMuscles: "Цільові м'язи",
            tabGuide: "Схема виконання",
            seoTitle: "Інструкції та помилки для {exercise} | Fit-Log",
            seoDescription: "Дізнайтеся, як правильно виконувати {exercise}, ознайомившись з інструкціями, обладнанням та частими помилками.",
        },
        auth: {

                    navLabel: "Автентифікація",

                    signInUp: "Увійти / Зареєструватися",

                    logout: "Вийти {name}",

                    logoutAria: "Вийти",

                    signInTitle: "Вхід | Легкий трекер для підходів, повторень і ваги",

                    signInDescription: "Увійдіть до Fit-Log.",

                    signUpTitle: "Реєстрація | Легкий трекер для підходів, повторень і ваги",

                    signUpDescription: "Створіть обліковий запис Fit-Log.",

                    signInHeading: "Вхід",

                    signUpHeading: "Реєстрація",

                },
        sso: {

                    title: "Завершення входу | Легкий трекер для підходів, повторень і ваги",

                    description: "Завершення входу до Fit-Log.",

                    heading: "Завершення входу",

                    message: "Завершення входу... Незабаром ви будете перенаправлені на головну сторінку.",

                },
        footer: {

                    copyright: "© {year} Fit-log.com. Усі права захищені.",

                },
        muscleGroups: {

                    trapezius: "Трапеції",

                    deltoids: "Дельти",

                    rear_deltoids: "Задні дельти",

                    chest: "Грудні",

                    upper_back: "Верх спини",

                    back: "Спина",

                    lower_back: "Низ спини",

                    biceps: "Біцепси",

                    triceps: "Трицепси",

                    forearms: "Передпліччя",

                    abs: "Прес",

                    obliques: "Косі м'язи",

                    hip_flexors: "Згиначі стегна",

                    glutes: "Сідниці",

                    legs: "Ноги",

                    quadriceps: "Квадрицепси",

                    hamstrings: "Біцепси стегна",

                    calves: "Литки",

                }
    },
};

export const languageOptions = [
    { value: "en", labelKey: "language.english" },
    { value: "uk", labelKey: "language.ukrainian" },
];

export const localeMap = {
    en: "en-US",
    uk: "uk-UA",
};




